import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../constants/layout/store/filterSlice";
import Select from "react-select";
import CustomDatePicker from "../../components/Custom-Datepicker";
import ProfileInput from "../../components/ProfilePic";
import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import FileUploader from "../../components/MultipleFileUploader";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import {
  GetServiceCaller,
  PostFormServiceCaller,
} from "../../services/serviceCaller";
import { API_URL } from "../../constants";
import moment from "moment";
import DOBDatePicker from "./component/DOB-Datepicker";

const EmployeeAdd = () => {
  const initialFormData = {
    Title: "",
    FirstName: "",
    MiddleName: "",
    LastName: "",
    FatherName: "",
    FatherDOB: null,
    Email: "",
    TotalYearExp: "",
    TotalMonthExp: "",
    AlternateEMail: "",
    MotherName: "",
    MotherDOB: null,
    IsInActive: "",
    UploadProfileImg: "",
    Gender_020: "",
    DateOfBirth: null,
    MobileNo1: "",
    MobileNo2: "",
    AccountID: "",
    IsRemotly: "",
    IsIntern: "",
    Location: "",
    ContactType_011: "",
    // Correpondence Address
    CorrepondenceAddressType: 823,
    PermanentAddressType: 822,
    CorrespondenceAddress: "",
    CorrespondenceState: "",
    CorrespondenceCountry: "",
    CorrespondenceZipCode: "",
    CorrespondenceAddressPrint: "",
    CorrespondenceCity: "",
    // Permanant Address
    permanentAddressCode: "",
    permanentAddressCountryID: "",
    permanentAddressStateID: "",
    permanentAddressCityID: "",
    permanentAddressZipCode: "",
    permanentPrintAddress: "",
    IsCopyAddress: "",
    SpouseName:"",
    Child1Name:"",
    Child2Name:"",
    employeeAttachments: [],
    qualification: [
      {
        QualificationType: "SSC",
        Qualification: "",
        Stream: "",
        Institute: "",
        University: "",
        YearOfPassing: "",
        Percentage: "",
        LineNo: "1",
      },
      {
        QualificationType: "HSC/Diploma",
        Qualification: "",
        Stream: "",
        Institute: "",
        University: "",
        YearOfPassing: "",
        Percentage: "",
        LineNo: "2",
      },
      {
        QualificationType: "Graduation",
        Qualification: "",
        Stream: "",
        Institute: "",
        University: "",
        YearOfPassing: "",
        Percentage: "",
        LineNo: "3",
      },
    ],
    identities: [
      {
        IdentityType_063: 1146,
        NameOnIdentity: "",
        IdentityNo: "",
        IssuingCountry: "",
        IssueDate: null,
        ExpiryDate: null,
        IdentityFile: "",  
        LineNo: "1",
      },
      {
        IdentityType_063: 1032,
        NameOnIdentity: "",
        IdentityNo: "",
        IssuingCountry: "",
        IssueDate: null,
        ExpiryDate: null,
        IdentityFile: "",  
        LineNo: "2",
      },
      {
        IdentityType_063: 1187,
        NameOnIdentity: "",
        IdentityNo: "",
        IssuingCountry: "",
        IssueDate: null,
        ExpiryDate: null,
        IdentityFile: "",  
        LineNo: "3",
      },
    ],
    empLocation: [],
    employment_history: [],
    files: [],
    filesize: [],
    PFNomineeName: "",
    PFNomineeRelation: "",
    GSTNo: "",
    VATNo: "",
    CSTNo: "",
    PANNo: "",
    GSTEffectiveDate: null,
    VATEffectiveDate: null,
    CSTEffectiveDate: null,
    STNo: "",
    WorkingStatus: "",
    STEffectiveDate: null,
    GSTRegistrationType_192: "",
    EmployeeCategory_057: "",
    LeaveAccrualType_155: null,
    ReferBy: null,
    ResignationDate: null,
    ConfirmationDate: null,
    RelivingDate: null,
    RelivingType_119: null,
    employeeDetails: [
      {
        LineNo: "1",
        ShiftID: "",
        DepartmentID: "",
        SubDepartmentID: null,
        DesignationID: "",
        FromDate: "",
        ToDate: "",
        ImmediateSuperiorID: "",
        Branch: "",
      },
    ],
    workingarea: [
      // { LineNo: "1", EmployeeType_069: "", Company: "", Branch: "" },
    ],
    BloodGroup_062: null,
    MaritalStatus_021: null,
    DateOfAnniversary: "",
    SpouseDOB:"",
    Child1DOB:"",
    Child2DOB:"",
    AppointmentDate: null,
    JoiningDate: null,
    PayrollJoiningDate: null,
    Apprenticeship: "",
    Bond: "",
    Incentives: "",
    JoiningBonus:"",
    OnPayroll: "",
    IsPartTime: "",
    employeebank: [
      {
        AccountNo: "",
        Bank: "",
        IFSCCode: "",
        Branch: "",
        DefaultBank: 0,
        LineNo: "1",
      },
    ],
    DeskPhoneNo: "",
    EmergencyPhoneNo: "",
    EmergencyContactName: "",
    EmergencyContactRelation: "",
    PersonalEmail: "",
    OfficeEmail: "",
    PayTo: "",
    Nationality: null,
    BranchID: "",
  };

  let tableSelectStyle = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const navigate = useNavigate();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Add Employee"));
  }, []);

  const [pageLoading, setPageLoading] = useState(true);
  const [submitted, setSubmit] = useState(false);
  let [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(initialFormData);
  console.log("formData;;;;", formData);
  const [titleOptions, setTitleOption] = useState([]);
  const [accountTypeOption, setAccounTypeOption] = useState([]);
  const [addressTypeOptions, setAddressTypeOptions] = useState([]);
  const [bloodGroupOptions, setBloodGroupOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [conatctTypeOptions, setContactTYpeOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [subDepartmentOptions, setSubDepartmentOptions] = useState([]);
  const [designationOptions, setDesignationOptions] = useState([]);
  const [employeeTypeOptions, setEmployeeTypeOptions] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [gstRegTypeOptions, setGstRegTypeOptions] = useState([]);
  const [identityIssueingOptions, setIdentityIssueingOptions] = useState([]);
  const [identityTypeOptions, setIdentityTypeOptions] = useState([]);
  const [immediateSuperiorOptions, setImmediateSuperiorOptions] = useState([]);
  const [leaveAcuralOptions, setLeaveAcrualTypeOptions] = useState([]);
  const [maritialStatusOptions, setMaritialStatusOptions] = useState([]);
  const [nationalityOptions, setNationalityOptions] = useState([]);
  const [referedByOptions, setReferedByOptions] = useState([]);
  const [relationTypeOptions, setRelationTypeOptions] = useState([]);
  const [relievingTypeOptions, setRelievingTypeOptions] = useState([]);
  const [brandTypeOptions, setBrandTypeOptions] = useState([]);
  const [subrandTypeOptions, setSubBrandTypeOptions] = useState([]);
  const [shiftsOptions, setShiftsOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [workingStatusOptions, setWorkingStatusOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [profilePicError, setProfilePicError] = useState("");
  const [cityIDOptions, setCityIDOptions] = useState("");

  const handleProfilePic = (image) => {
    setFormData((prevData) => ({
      ...prevData,
      UploadProfileImg: image,
    }));
    setProfilePicError("");
  };

  const handleFile = (files) => {
    if (!files || files.length === 0) {
      alert("Please select a valid file under 5MB.");
      return;
    }

    const fileList = Array.from(files).filter(
      (file) => file.size <= 5 * 1024 * 1024
    ); // Filter files under 5MB

    if (fileList.length === 0) {
      alert("All selected files exceed 5MB.");
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      files: [...prevData.files, ...fileList], // Store full file objects
      filesize: [
        ...prevData.filesize,
        ...fileList.map((file) => (file.size / 1024 / 1024).toFixed(2) + " MB"),
      ],
    }));
  };

  const removeFile = (indexToRemove) => {
    setFormData((prevData) => ({
      ...prevData,
      files: prevData.files.filter((_, index) => index !== indexToRemove),
      filesize: prevData.filesize.filter((_, index) => index !== indexToRemove),
    }));
  };
  const schema = Yup.object().shape({
    Title: Yup.number()
      .typeError("Title is required")
      .required("Title is required"),
    BranchID: Yup.number()
      .typeError("Branch is required")
      .required("Branch is required"),
    FirstName: Yup.string().required("First Name is required"),
    MiddleName: Yup.string().nullable(),
    LastName: Yup.string().required("Last Name is required"),
    FatherName: Yup.string().nullable(),
    FatherDOB: Yup.string().nullable(),
    MotherName: Yup.string().nullable(),
    TotalYearExp: Yup.string()
    .typeError("Total Year Exp is required")
    .required("Total Year Exp is required"),
    TotalMonthExp: Yup.string() 
    .typeError("Total Month Exp is required")
    .required("Total Month Exp is required"),
    MotherDOB: Yup.string().nullable(),
    IsInActive: Yup.string().nullable(),
    UploadProfileImg: Yup.mixed().required("Profile picture is required."),
    ContactType_011: Yup.number()
      .typeError("Contact Type is required")
      .required("Contact Type is required"),
    AccountType: Yup.number()
      .typeError("Account Type is required")
      .required("Account Type is required"),
    Gender_020: Yup.number()
      .typeError("Gender is required")
      .required("Gender is required"),
    DateOfBirth: Yup.string().required("Date of Birth is required"),
    MobileNo1: Yup.string()
      .required("Mobile No is required")
      .matches(/^\d{10}$/, "Mobile No must be exactly 10 digits"),
    MobileNo2: Yup.string()
      .nullable()
      .matches(/^\d{10}$/, "Mobile No must be exactly 10 digits"),
    DeskPhoneNo: Yup.string().nullable(),
    EmergencyPhoneNo: Yup.string().required("Emergency PhoneNo is required").matches(/^\d{10}$/, "Mobile No must be exactly 10 digits"),
    EmergencyContactName: Yup.string().required(
      "Emergency Contact Name is Required"
    ),
    EmergencyContactRelation: Yup.string().required(
      "Contact Relation In Required"
    ),
    PersonalEmail: Yup.string().required("Personal Email is Required"),
    OfficeEmail: Yup.string().required("NSS Email is Required"),
    Location: Yup.string().required("Joining Location required"),
    WorkingRemote: Yup.string().nullable(),
    CorrepondenceAddressType: Yup.mixed().nullable(),
    CorrespondenceAddress: Yup.string().required("Address is Required"),
    CorrespondenceCountry: Yup.number()
      .typeError("Country is required")
      .required("Country is required"),
    CorrespondenceState: Yup.number()
      .typeError("State is required")
      .required("State is required"),
    CorrespondenceCity: Yup.number()
      .typeError("City is required")
      .required("City is required"),
    CorrespondenceZipCode: Yup.string(),
    CorrespondenceAddressPrint: Yup.string(),
    permanentAddressCode: Yup.string(),
    permanentAddressCityID: Yup.string(),
    permanentAddressStateID: Yup.string(),
    permanentAddressCountryID: Yup.string(),
    permanentAddressZipCode: Yup.string(),
    employeebank: Yup.array()
      .of(
        Yup.object().shape({
          AccountNo: Yup.string()
            .matches(/^\d{9,18}$/, "Account No must be between 9-18 digits")
            .required("Account No is required"),
          Branch: Yup.string().nullable(),
          Bank: Yup.string().required("Bank is required"),
          IFSCCode: Yup.string()
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC Code format")
            .required("IFSC Code is required"),
          DefaultBank: Yup.number() // Changed from string to number
            .oneOf([0, 1], "Invalid Default Bank value")
            .test(
              "at-least-one-default",
              "At least one bank must be set as default",
              function (value, context) {
                // Check if at least one item in the array has DefaultBank === 1
                if (context.parent.DefaultBank === 1) return true; // Current item is default

                // Check other items in the array
                const parentArray = context.from[1].value.employeebank || [];
                return parentArray.some((item) => item.DefaultBank === 1);
              }
            ),
        })
      )
      .min(1, "At least one bank detail is required"),

    GSTNo: Yup.string().nullable(),
    VATNo: Yup.string().nullable(),
    CSTNo: Yup.string().nullable(),
    PANNo: Yup.string().nullable(),
    GSTEffectiveDate: Yup.string().nullable(),
    VATEffectiveDate: Yup.string().nullable(),
    CSTEffectiveDate: Yup.string().nullable(),
    STNo: Yup.string().nullable(),
    GSTRegistrationType_192: Yup.mixed().nullable(),
    STEffectiveDate: Yup.string().nullable(),
    WorkingStatus: Yup.mixed().nullable(),
    LeaveAccrualType_155: Yup.number()
      .nullable()
      .test(
        "is-mandatory",
        "Leave Accrual Type is required",
        function (value) {
          const { employeeDetails } = this.parent;
          if (employeeDetails && employeeDetails.length > 0) {
            const isActiveIntern = employeeDetails.some(
              (detail) =>
                String(detail.DesignationID) === "178" &&
                (!detail.ToDate || detail.ToDate === "")
            );
            if (isActiveIntern) {
              return true;
            }
          }
          return value !== null && value !== undefined && value !== "";
        }
      ),
    ReferBy: Yup.number().nullable(),
    ResignationDate: Yup.string().nullable(),
    ConfirmationDate: Yup.string().nullable(),
    RelivingDate: Yup.string().nullable(),
    RelivingType_119: Yup.number().nullable(),

    employeeDetails: Yup.array().of(
      Yup.object().shape({
        ShiftID: Yup.string().required("Shift is required"),
        Branch: Yup.string().required("Branch is required"),
        DepartmentID: Yup.string().required("Department is required"),
        SubDepartmentID: Yup.string().nullable(),
        DesignationID: Yup.string().required("Designation is required"),
        ImmediateSuperiorID: Yup.string().required(
          "Immediate Superior is required"
        ),
        FromDate: Yup.string().required("From Date is required"),
      })
    ),

    workingarea: Yup.array().of(
      Yup.object().shape({
        EmployeeType_069: Yup.string().nullable(),
        Branch: Yup.string().nullable(),
      })
    ),
    // .min(1, "At least one Working Area is required"),

    employeeAttachments: Yup.mixed().nullable(),

    qualification: Yup.array()
      .of(
        Yup.object().shape({
          QualificationType: Yup.string().required(
            "Qualification Type is required"
          ),
          Qualification: Yup.string().nullable(),
        })
      )
      .when("qualifications", {
        is: (value) => value && value.length > 0, // if array is not empty
        then: Yup.array().min(1, "At least one qualification is required"),
      }),

    identities: Yup.array()
      .of(
        Yup.object().shape({
          IdentityType_063: Yup.string().required("Identity Type is required"),
          NameOnIdentity: Yup.string().required(
            "Name On Indentity Is Required"
          ),
          IdentityNo: Yup.string().required("Indentity No Is Required"),
          IssuingCountry: Yup.string().required("Country Is Required"),
          IssueDate: Yup.string().nullable(),
          File: Yup.mixed().nullable(),
        })
      )
      .min(1, "At least one identity is required"),

    BloodGroup_062: Yup.number()
      .typeError("Blood Group is required")
      .required("Blood Group is required"),
    PFNomineeName: Yup.string().required("PF Nominee Name is required"),
    PFNomineeRelation: Yup.string().required("PF Nominee Relation is required"),
    SpouseName: Yup.string().nullable(),
    Child1Name: Yup.string().nullable(),
    Child2Name: Yup.string().nullable(),
    MaritalStatus_021: Yup.mixed().nullable(),
    Nationality: Yup.mixed().nullable(),
    DateOfAnniversary: Yup.string().nullable(),
    SpouseDOB:Yup.string().nullable(),
    Child1DOB:Yup.string().nullable(),
    Child2DOB:Yup.string().nullable(),
    AppointmentDate: Yup.string().required("Appointment Date is Required"),
    JoiningDate: Yup.string().required("Joining Date is Required"),
    PayrollJoiningDate: Yup.string().required(
      "Payroll Joining Date is Required"
    ),
    // Branch: Yup.number()
    //   .typeError("Branch is required")
    //   .required("Branch is required"),
    OnPayroll: Yup.string().nullable().nullable(),
    IsIntern: Yup.string().nullable().nullable(),
    Partime: Yup.string().nullable().nullable(),
    Apprenticeship:  Yup.string().nullable().nullable(),
    Bond: Yup.string().nullable().nullable(),
    Incentives: Yup.string().nullable().nullable(),
    JoiningBonus: Yup.string().nullable().nullable(),
    BandType_2015: Yup.number().required("Band is Required"),
    SubBandType_2015: Yup.number().required("Sub Band is Required"),
  });

  // Validate individual field
  const validateField = async (fieldName, updatedData) => {
    try {
      await schema.validateAt(fieldName, updatedData);
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: err.message,
      }));

      if (fieldName.startsWith("lines")) {
        toast.error(err.message, { position: "top-right" });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmit(true);
    try {
      if (!formData.UploadProfileImg) {
        setSubmit(false);
        setProfilePicError("Profile picture is required.");
        toast.error("Profile picture is required.");
        return;
      }

      await schema.validate(formData, { abortEarly: false });
      setErrors({});
      setProfilePicError(""); // Clear errors if validation passes

      // Ensure DateOfAnniversary is formatted correctly
      const formattedFormData = {
        ...formData,
        DateOfAnniversary: formData.DateOfAnniversary
          ? moment(formData.DateOfAnniversary).format("YYYY-MM-DD")
          : null,
        RelivingDate: formData.RelivingDate
          ? moment(formData.RelivingDate).format("YYYY-MM-DD")
          : null,
        GSTEffectiveDate: formData.GSTEffectiveDate
          ? moment(formData.GSTEffectiveDate).format("YYYY-MM-DD")
          : null,
        VATEffectiveDate: formData.VATEffectiveDate
          ? moment(formData.VATEffectiveDate).format("YYYY-MM-DD")
          : null,
        CSTEffectiveDate: formData.CSTEffectiveDate
          ? moment(formData.CSTEffectiveDate).format("YYYY-MM-DD")
          : null,
        STEffectiveDate: formData.STEffectiveDate
          ? moment(formData.STEffectiveDate).format("YYYY-MM-DD")
          : null,
        SpouseDOB: formData.SpouseDOB
          ? moment(formData.SpouseDOB).format("YYYY-MM-DD")
          : null,
        Child1DOB: formData.Child1DOB
          ? moment(formData.Child1DOB).format("YYYY-MM-DD")
          : null,
        Child2DOB: formData.Child2DOB
          ? moment(formData.Child2DOB).format("YYYY-MM-DD")
          : null,

        qualification: formData.qualification.map((q) => {
          if (q[0]) {
            delete q[0];
          }
          return q;
        }),
        identities: formData.identities.map((q) => {
          if (q[0]) {
            delete q[0];
          }
          return q;
        }),
        employeebank: formData.employeebank.map((q) => {
          if (q[0]) {
            delete q[0];
          }
          return q;
        }),

        // Convert file sizes from MB to KB
        filesize: formData.files.map(
          (file) => `${(file.size / 1024).toFixed(2)} KB`
        ),
      };

      // API call using Axios
      const response = await PostFormServiceCaller(
        `${API_URL}rujul/employee-data`,
        formattedFormData,
        "post"
      );

      // Handle success response (optional)
      if (response.status === 200) {
        setSubmit(false);
        toast.success("Form submitted successfully!");
        setTimeout(() => {
          navigate("/employee-list");
        }, 2000);
      }
    } catch (error) {
      setSubmit(false);

      if (error.inner) {
        const newErrors = {};
        error.inner.forEach((err) => {
          newErrors[err.path] = err.message;
          if (err.path === "UploadProfileImg") {
            setProfilePicError(err.message);
          }
          toast.error(err.message);
        });
        setErrors(newErrors); // Update state with errors
      } else {
        console.error("API Error:", error);
        toast.error("Failed to submit the form."); // Using Toastify
      }
    }
  };

  const fetchState = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-state-city/${id}`
      );
      if (response.status === 200) {
        const cleanedData = response?.data?.StateCity || [];
        console.log("cleanedData", cleanedData);

        const options = cleanedData.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        setStateOptions(options);
      } else {
        console.error(
          "Failed to fetch states. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    } finally {
      setPageLoading(false);
    }
  };

  const fetchCity = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-state-city/${id}`
      );
      if (response.status === 200) {
        const cleanedData = response?.data?.StateCity || [];

        const options = cleanedData.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        setCityOptions(options);
      } else {
        console.error(
          "Failed to fetch cities. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    } finally {
      setPageLoading(false);
    }
  };

  const handleSelect = async (selectedOption, name, e) => {
    const value = selectedOption.value;

    setFormData((prevState) => {
      let updatedData = { ...prevState, [name]: value }; // Update selected value

      // Handle country selection for both Correspondence and Permanent Address
      if (
        name === "CorrespondenceCountry" ||
        name === "permanentAddressCountryID"
      ) {
        updatedData = {
          ...updatedData,
          CorrespondenceState:
            name === "CorrespondenceCountry"
              ? null
              : prevState.CorrespondenceState,
          CorrespondenceCity:
            name === "CorrespondenceCountry"
              ? null
              : prevState.CorrespondenceCity,
          permanentAddressStateID:
            name === "permanentAddressCountryID"
              ? null
              : prevState.permanentAddressStateID,
          permanentAddressCityID:
            name === "permanentAddressCountryID"
              ? null
              : prevState.permanentAddressCityID,
        };
      }
      // Handle state selection for both Correspondence and Permanent Address
      else if (
        name === "CorrespondenceState" ||
        name === "permanentAddressStateID"
      ) {
        updatedData = {
          ...updatedData,
          CorrespondenceCity:
            name === "CorrespondenceState"
              ? null
              : prevState.CorrespondenceCity,
          permanentAddressCityID:
            name === "permanentAddressStateID"
              ? null
              : prevState.permanentAddressCityID,
        };
      }

      // Update CorrespondenceAddressPrint with labels instead of values
      updatedData.CorrespondenceAddressPrint = [
        updatedData.CorrespondenceAddress,
        cityOptions.find(
          (option) => option.value === updatedData.CorrespondenceCity
        )?.label,
        stateOptions.find(
          (option) => option.value === updatedData.CorrespondenceState
        )?.label,
        countryOptions.find(
          (option) => option.value === updatedData.CorrespondenceCountry
        )?.label,
        updatedData.CorrespondenceZipCode,
      ]
        .filter(Boolean)
        .join(", ");

      // Update Permanent Address Print
      updatedData.permanentPrintAddress = [
        updatedData.permanentAddressCode, // Ensure this is correct
        cityOptions.find(
          (option) => option.value === updatedData.permanentAddressCityID
        )?.label,
        stateOptions.find(
          (option) => option.value === updatedData.permanentAddressStateID
        )?.label,
        countryOptions.find(
          (option) => option.value === updatedData.permanentAddressCountryID
        )?.label,
        updatedData.permanentAddressZipCode,
      ]
        .filter(Boolean)
        .join(", ");

      validateField(name, updatedData);
      return updatedData;
    });

    // Fetch states or cities based on selection
    if (
      name === "CorrespondenceCountry" ||
      name === "permanentAddressCountryID"
    ) {
      await fetchState(value);
    } else if (
      name === "CorrespondenceState" ||
      name === "permanentAddressStateID"
    ) {
      await fetchCity(value);
    }
    if (name === "BandType_2015") {
      setSubBrandTypeOptions([]);

      setFormData((prev) => ({
        ...prev,
        SubBandType_2015: "", // reset selected value
      }));
  try {
    const res = await GetServiceCaller(
        `${API_URL}rujul/band-designation-tracking-data/${value}`);
    const data = await res.data.data;
    console.log('data',data);
    

    const formattedOptions = data.map((item) => ({
      value: item.ID,
      label: item.SubDetailName,
    }));

    setSubBrandTypeOptions(formattedOptions);

    // Optional: reset sub-brand when brand changes
    setFormData((prev) => ({
      ...prev,
      SubBandType_2015: "",
    }));
  } catch (error) {
    console.error("Error fetching sub band:", error);
  }
}

    // Clear errors for valid selection
    setErrors((errors) => ({
      ...errors,
      [name]: "",
    }));
  };

  const handleChange = async (e) => {
    console.log("e:::::", e);

    const { name, value } = e.target;
    console.log("name, value", name, value);

    if (schema.fields[name]) {
      setFormData((prevData) => {
        const updatedData = {
          ...prevData,
          [name]: name === "IsInActive" ? Number(value) : value, // Convert to number if radio button
        };
        // Use labels for Correspondence Address
        updatedData.CorrespondenceAddressPrint = [
          updatedData.CorrespondenceAddress,
          cityOptions.find(
            (option) => option.value === updatedData.CorrespondenceCity
          )?.label,
          stateOptions.find(
            (option) => option.value === updatedData.CorrespondenceState
          )?.label,
          countryOptions.find(
            (option) => option.value === updatedData.CorrespondenceCountry
          )?.label,
          updatedData.CorrespondenceZipCode,
        ]
          .filter(Boolean)
          .join(", ");

        // Use labels for Permanent Address
        updatedData.permanentPrintAddress = [
          updatedData.permanentAddressCode,
          cityOptions.find(
            (option) => option.value === updatedData.permanentAddressCityID
          )?.label,
          stateOptions.find(
            (option) => option.value === updatedData.permanentAddressStateID
          )?.label,
          countryOptions.find(
            (option) => option.value === updatedData.permanentAddressCountryID
          )?.label,
          updatedData.permanentAddressZipCode,
        ]
          .filter(Boolean)
          .join(", ");

        validateField(name, updatedData);
        return updatedData;
      });
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: checked ? "1" : "0",
    }));
  };

  const handleAllLineChange = async (e, index, section) => {
    const { name, type, checked, value } = e.target;
    const updatedSection = [...formData[section]];
    const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;
    if (name === "DefaultBank" && newValue === 1) {
      const alreadySelected = updatedSection.find(
        (item, idx) => item.DefaultBank === 1 && idx !== index
      );
      if (alreadySelected) {
        toast.error("Only one Default Bank can be selected.");
        return; // Block further execution
      }
    }
    updatedSection[index][name] = newValue;

    try {
      await schema.validateAt(`${section}[${index}].${name}`, {
        [section]: updatedSection,
      });

      // Update form state and clear errors if valid
      setFormData((prevState) => ({
        ...prevState,
        [section]: updatedSection,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        [section]: {
          ...prevErrors[section],
          [index]: { ...prevErrors[section]?.[index], [name]: "" },
        },
      }));
    } catch (err) {
      // Set validation error message
      setErrors((prevErrors) => ({
        ...prevErrors,
        [section]: {
          ...prevErrors[section],
          [index]: { ...prevErrors[section]?.[index], [name]: err.message },
        },
      }));
    }
  };

  const handleLineSelect = async (selectedOption, name, index, section) => {
    console.log("select---->", selectedOption, name, section, index);
    const updatedSection = [...formData[section]];
    updatedSection[index][name] = selectedOption.value;
    // Update both CityID and CityName when CityID is selected
    if (name === "CityID") {
      updatedSection[index]["CityName"] = selectedOption.label;
    }
    try {
      // Validate specific field dynamically from schema
      await schema.validateAt(`${section}[${index}].${name}`, {
        [section]: updatedSection,
      });

      // Update form state and clear errors if valid
      setFormData((prevState) => ({
        ...prevState,
        [section]: updatedSection,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        [section]: {
          ...prevErrors[section],
          [index]: {
            ...prevErrors[section]?.[index],
            [name]: "",
            ...(name === "CityID" && { CityName: "" }),
          },
        },
      }));
    } catch (err) {
      // Set validation error message
      setErrors((prevErrors) => ({
        ...prevErrors,
        [section]: {
          ...prevErrors[section],
          [index]: {
            ...prevErrors[section]?.[index],
            [name]: err.message,
            ...(name === "CityID" && { CityName: err.message }),
          },
        },
      }));
    }
  };

  const handleAddLine = (e, arrayName, defaultRowStructure, keyToCheck) => {
    e.preventDefault();
    console.log(
      "defaultRowStructure",
      e,
      arrayName,
      defaultRowStructure,
      keyToCheck
    );

    // Get the last row in the specified array
    const currentArray = formData[arrayName] || []; // Default to an empty array if undefined
    const currentRow =
      currentArray.length !== 0 ? currentArray[currentArray.length - 1] : null;

    // vaidation Add in Location History
    if (arrayName === 'empLocation' && currentArray.length > 0) {
      const lastRow = currentArray[currentArray.length - 1];

      const requiredFields = ['CityID', 'FromDate', 'ToDate'];
      const isIncomplete = requiredFields.some(field =>
        !lastRow[field] || lastRow[field] === ""
      );

      if (isIncomplete) {
        toast.error("Please fill all fields in the current row before adding a new one");
        return;
      }
    }


    // Find the smallest missing line number
    let newLineNo =
      currentArray.length > 0
        ? Math.max(...currentArray.map((row) => row.LineNo)) + 1
        : 1;

    // Log the new line number for debugging
    console.log(`Adding row to ${arrayName} with LineNo:`, newLineNo);

    // Create a new row with dynamic structure
    const newRow = {
      LineNo: newLineNo,
      ID: "",
      AccountNo: "",
      Bank: "",
      IFSCCode: "",
      Branch: "",
      DefaultBank: 0,
    };

    // Ensure prevState[arrayName] is always an array
    setFormData((prevState) => ({
      ...prevState,
      [arrayName]: [...(prevState[arrayName] || []), newRow], // Fix: Ensure it's an array
    }));
  };
  const deleteLine = (e, arrayName, lineNoToDelete) => {
    e.preventDefault();

    setFormData((prevState) => ({
      ...prevState,
      [arrayName]: prevState[arrayName].filter(
        (row) => row.LineNo !== lineNoToDelete
      ),
    }));
  };

  const handleIdentityFileChange = (files, index) => { 

    if (!files || files.length === 0) return;

    const file = files[0];

    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG, PNG and PDF files are allowed.");
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5 MB

    if (file.size > maxSize) {
      toast.error("File size should not exceed 5MB.");
      return;
    }

    setFormData((prev) => {
      const identities = [...prev.identities];

      identities[index] = {
        ...identities[index],
        IdentityFile: file,
        IdentityFilePreview: URL.createObjectURL(file),
      };

      return {
        ...prev,
        identities,
      };
    });
  };

  const handleQualFileChange = (files, index) => {
    if (!files || files.length === 0) return;
    const file = files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG, PNG and PDF files are allowed.");
      return;
    }
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error("File size should not exceed 5MB.");
      return;
    }
    setFormData((prev) => {
      const qualification = [...prev.qualification];
      qualification[index] = {
        ...qualification[index],
        QualificationFile: file,
        QualificationFilePreview: URL.createObjectURL(file),
      };
      return { ...prev, qualification };
    });
  };

  const handleEmploymentFileChange = (files, index, fieldName) => {
    if (!files || files.length === 0) return;
    const file = files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG, PNG and PDF files are allowed.");
      return;
    }
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error("File size should not exceed 5MB.");
      return;
    }
    setFormData((prev) => {
      const employment_history = [...(prev.employment_history || [])];
      employment_history[index] = {
        ...employment_history[index],
        [fieldName]: file,
        [`${fieldName}Preview`]: URL.createObjectURL(file),
      };
      return { ...prev, employment_history };
    });
  };

   const fetchSubDepartment = async (deptId) => {
      try {
  
        if (!deptId) return;

        setSubDepartmentOptions([]);
  
        const res = await GetServiceCaller(
          `${API_URL}sub-department/${deptId}`
        );
  
        const data = res.data.data;

        const formattedOptions = data
          .filter(item => item.ID !== null && item.Name !== null)
          .map((item) => ({
            value: String(item.ID),
            label: item.Name,
          }));
  
        setSubDepartmentOptions(formattedOptions);
  
      } catch (error) {
        console.error(error);
      }
    };

  useEffect(() => {
    fetchIndexData();
    fetchSubDepartment();
  }, []);

  const fetchIndexData = async () => {
    try {
      let response = await GetServiceCaller(`${API_URL}rujul/employee-data`);
      if (response?.status === 200) {
        console.log("response:::", response);
        setPageLoading(false);
        // title option
        const titlesOpt = response?.data?.data?.titles?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setTitleOption(titlesOpt);

        const accTypeOpt = response?.data?.data?.account_type?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setAccounTypeOption(accTypeOpt);
        const addressTypeOptions = response?.data?.data?.addressType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setAddressTypeOptions(addressTypeOptions);
        const bloodGrpOpt = response?.data?.data?.blood_group?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setBloodGroupOptions(bloodGrpOpt);
        const branchOpt = response?.data?.data?.branches?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setBranchOptions(branchOpt);
        const cityIdOpt = response?.data?.data?.city?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setCityIDOptions(cityIdOpt);
        const compOpt = response?.data?.data?.company?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setCompanyOptions(compOpt);
        const contactTypeOpt = response?.data?.data?.contact_type?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setContactTYpeOptions(contactTypeOpt.filter((o) => o.value === 32));
        const countryOpt = response?.data?.data?.country?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setCountryOptions(countryOpt);
        const deptOpt = response?.data?.data?.department?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setDepartmentOptions(deptOpt);
        const desigOpt = response?.data?.data?.designation?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setDesignationOptions(desigOpt);
        const empOpt = response?.data?.data?.employee_type?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setEmployeeTypeOptions(empOpt);
        const genderOpt = response?.data?.data?.gender?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setGenderOptions(genderOpt);
        const gstTypeOpt = response?.data?.data?.gstRegType?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setGstRegTypeOptions(gstTypeOpt);
        const identityIssueOpt =
          response?.data?.data?.identityIssueingCountry?.map((option) => ({
            label: option.text,
            value: option.value,
          }));
        setIdentityIssueingOptions(identityIssueOpt);
        const identityTypeOpt = response?.data?.data?.identityType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setIdentityTypeOptions(identityTypeOpt);
        if (identityTypeOpt && identityTypeOpt.length > 0) {
          const aadharOpt = identityTypeOpt.find((o) => o.label.toLowerCase().includes("aadhar") || o.label.toLowerCase().includes("aadhaar"));
          const panOpt = identityTypeOpt.find((o) => o.label.toLowerCase().includes("pan"));
          const passportOpt = identityTypeOpt.find((o) => o.label.toLowerCase().includes("passport"));

          if (aadharOpt || panOpt || passportOpt) {
            setFormData((prev) => {
              if (prev.identities && prev.identities.length === 3) {
                return {
                  ...prev,
                  identities: [
                    { ...prev.identities[0], IdentityType_063: aadharOpt ? aadharOpt.value : prev.identities[0].IdentityType_063 },
                    { ...prev.identities[1], IdentityType_063: panOpt ? panOpt.value : prev.identities[1].IdentityType_063 },
                    { ...prev.identities[2], IdentityType_063: passportOpt ? passportOpt.value : prev.identities[2].IdentityType_063 },
                  ],
                };
              }
              return prev;
            });
          }
        }
        const immediateManagerOpt =
          response?.data?.data?.immediate_manager?.map((option) => ({
            label: option.text,
            value: option.value,
          }));
        setImmediateSuperiorOptions(immediateManagerOpt);
        const leaveAcrualTypeOpt = response?.data?.data?.leaveAcrualType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setLeaveAcrualTypeOptions(leaveAcrualTypeOpt);
        const maritialStatusOpt = response?.data?.data?.maritial_status?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setMaritialStatusOptions(maritialStatusOpt);
        const nationalityOpt = response?.data?.data?.nationality?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setNationalityOptions(nationalityOpt);
        const referOpt = response?.data?.data?.referredBy?.map((option) => ({
          label: option.TEXT,
          value: option.VALUE,
        }));
        setReferedByOptions(referOpt);
        const reletionTypeOpt = response?.data?.data?.relationType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setRelationTypeOptions(reletionTypeOpt);
        const relievingTypeOpt = response?.data?.data?.relievingType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setRelievingTypeOptions(relievingTypeOpt);
        const brandTypeOpt = response?.data?.data?.brand?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setBrandTypeOptions(brandTypeOpt);
        const subrandTypeOptions = response?.data?.data?.subbrand?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setSubBrandTypeOptions(subrandTypeOptions);
        const shiftsOpt = response?.data?.data?.shifts?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setShiftsOptions(shiftsOpt);
        // const stateOpt = response?.data?.data?.state?.map((option) => ({
        //   label: option.text,
        //   value: option.value,
        // }));
        // setStateOptions(stateOpt);
        const workingStatOpt = response?.data?.data?.workingStatus?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setWorkingStatusOptions(workingStatOpt);
        const bankOpt = response?.data?.data?.bank?.map((option) => ({
          label: option.Name,
          value: option.ID,
        }));
        setBankOptions(bankOpt);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container Support-Padding">
          <form
            id="formOne"
            className="rounded mt-2 bg-white"
            onSubmit={handleSubmit}
          >
            <div className="container-fluid overflow-x-auto">
              <ul
                className="nav nav-tabs flex flex-nowrap w-max space-x-2"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    style={{ color: "#2F2E4B" }}
                    id="general-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#general"
                    type="button"
                    role="tab"
                    aria-controls="general"
                    aria-selected="true"
                  >
                    General
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="personal-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#personal"
                    type="button"
                    role="tab"
                    aria-controls="personal"
                    aria-selected="false"
                  >
                    Contact
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="project-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#project"
                    type="button"
                    role="tab"
                    aria-controls="project"
                    aria-selected="false"
                  >
                    Bank
                  </button>
                </li>
                {/* <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="rating-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#rating"
                    type="button"
                    role="tab"
                    aria-controls="rating"
                    aria-selected="false"
                  >
                    Tax
                  </button>
                </li> */}
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="other-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#other"
                    type="button"
                    role="tab"
                    aria-controls="other"
                    aria-selected="false"
                  >
                    HR
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="areas-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#areas"
                    type="button"
                    role="tab"
                    aria-controls="areas"
                    aria-selected="false"
                  >
                    Working Areas
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="locationhistory-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#locationhistory"
                    type="button"
                    role="tab"
                    aria-controls="locationhistory"
                    aria-selected="false"
                  >
                    Location History
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="attachment-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#attachment"
                    type="button"
                    role="tab"
                    aria-controls="attachment"
                    aria-selected="false"
                  >
                    Attachments
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="qualification-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#qualification"
                    type="button"
                    role="tab"
                    aria-controls="qualification"
                    aria-selected="false"
                  >
                    Qualification
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="identities-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#identities"
                    type="button"
                    role="tab"
                    aria-controls="identities"
                    aria-selected="false"
                  >
                    Identities
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="employmentdetails-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#employmentdetails"
                    type="button"
                    role="tab"
                    aria-controls="employmentdetails"
                    aria-selected="false"
                  >
                    Employment Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="additional-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#additional"
                    type="button"
                    role="tab"
                    aria-controls="additional"
                    aria-selected="false"
                  >
                    Additional
                  </button>
                </li>
              </ul>
            </div>
            <div className="tab-content" id="myTabContent">
              {/* General Details */}
              <div
                className="tab-pane fade show active"
                id="general"
                role="tabpanel"
                aria-labelledby="general-tab"
              >
                <div className="container-fluid mt-3">
                  <div className="row">
                    <div className="col-md-10">
                      <div className="row">
                        <div className="col-md-3">
                          <label className="form-label">
                            Title <span className="required">*</span>
                          </label>
                          <Select
                            name="Title"
                            options={[
                              { value: "", label: "Select" },
                              ...titleOptions,
                            ]}
                            className={` ${errors.Title ? "is-invalid" : ""}`}
                            value={titleOptions.find(
                              (option) => option.value === formData?.Title
                            )}
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                          />
                          {errors.Title && (
                            <div className="error">{errors.Title}</div>
                          )}
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="FirstName" className="form-label">
                              First Name
                              <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="First Name"
                              className={`form-control ${errors.FirstName ? "is-invalid" : ""
                                }`}
                              id="FirstName"
                              name="FirstName"
                              value={formData?.FirstName}
                              onChange={(e) => handleChange(e)}
                            />
                            {errors.FirstName && (
                              <div className="error">{errors.FirstName}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="MiddleName" className="form-label">
                              Middle Name
                            </label>
                            <input
                              type="text"
                              placeholder="Middle Name"
                              className="form-control"
                              id="MiddleName"
                              name="MiddleName"
                              value={formData?.MiddleName}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="LastName" className="form-label">
                              Last Name
                              <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Last Name"
                              className={`form-control ${errors.LastName ? "is-invalid" : ""
                                }`}
                              id="LastName"
                              name="LastName"
                              value={formData?.LastName}
                              onChange={(e) => handleChange(e)}
                            />
                            {errors.LastName && (
                              <div className="error">{errors.LastName}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="FatherName" className="form-label">
                              Father Name
                            </label>
                            <input
                              type="text"
                              placeholder="Father's Name"
                              className="form-control"
                              id="FatherName"
                              name="FatherName"
                              value={formData?.FatherName}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="FatherDOB" className="form-label">
                              Father's DOB
                            </label>
                            <CustomDatePicker
                              name="FatherDOB"
                              id="FatherDOB"
                              placeholderText="DD-MMM-YYYY"
                              className="form-control"
                              value={formData?.FatherDOB}
                              handleChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div> */}
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="MotherName" className="form-label">
                              Mother Name
                            </label>
                            <input
                              type="text"
                              placeholder="Mother's Name"
                              className="form-control"
                              id="MotherName"
                              name="MotherName"
                              value={formData?.MotherName}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="MotherDOB" className="form-label">
                              Mother's DOB
                            </label>
                            <CustomDatePicker
                              name="MotherDOB"
                              id="MotherDOB"
                              value={formData?.MotherDOB}
                              placeholderText="DD-MMM-YYYY"
                              className="form-control"
                              handleChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div> */}
                        <div className="col-md-3">
                          <div className="">
                            <label className="form-label">
                              Contact Type <span className="required">*</span>
                            </label>
                            <Select
                              name="ContactType_011"
                              options={[
                                { value: "", label: "Select" },
                                ...conatctTypeOptions,
                              ]}
                              className={` ${errors.ContactType_011 ? "is-invalid" : ""
                                }`}
                              value={conatctTypeOptions.find(
                                (option) =>
                                  option.value === formData?.ContactType_011
                              )}
                              // value={formData?.ContactType}
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                            />

                            {errors.ContactType_011 && (
                              <div className="error">
                                {errors.ContactType_011}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="">
                            <label className="form-label">
                              Account <span className="required">*</span>
                            </label>
                            <Select
                              name="AccountType"
                              options={[
                                { value: "", label: "Select" },
                                ...accountTypeOption,
                              ]}
                              // value={formData?.AccountType}
                              value={accountTypeOption.find(
                                (option) =>
                                  option.value === formData?.AccountType
                              )}
                              className={` ${errors.AccountType ? "is-invalid" : ""
                                }`}
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                            />
                            {errors.AccountType && (
                              <div className="error">{errors.AccountType}</div>
                            )}
                          </div>
                        </div>

                        <div className="col-sm-2">
                          <div className="">
                            <label className="form-label">
                              Gender <span className="required">*</span>
                            </label>
                            <Select
                              name="Gender_020"
                              // value={formData?.Gender_020}
                              value={genderOptions.find(
                                (option) =>
                                  option.value === formData?.Gender_020
                              )}
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                              className={` ${errors.Gender_020 ? "is-invalid" : ""
                                }`}
                              options={[
                                { value: "", label: "Select" },
                                ...genderOptions,
                              ]}
                            />
                            {errors.Gender_020 && (
                              <div className="error">{errors.Gender_020}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <label className="form-label">
                            Date Of Birth<span className="required">*</span>
                          </label>
                          <DOBDatePicker
                            name="DateOfBirth"
                            id="DateOfBirth"
                            placeholderText="DD-MMM-YYYY"
                            value={formData?.DateOfBirth}
                            handleChange={(e) => handleChange(e)}
                            required={true}
                            className={`form-control ${errors?.DateOfBirth ? "is-invalid" : ""
                              }`}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={100} // Shows enough years to cover 18+ range
                            minDate={new Date(1900, 0, 1)} // Optional: set a reasonable minimum date
                            maxDate={
                              new Date(new Date().getFullYear() - 18, 11, 31)
                            } // Maximum date is 18 years ago
                          />
                          {errors.DateOfBirth && (
                            <span class="error">{errors?.DateOfBirth}</span>
                          )}
                        </div>
                        <div className="col-sm-2">
                          <label htmlFor="IsInActive" className="form-label">
                            Active
                          </label>
                          <div className="me-2 mt-0">
                            <div className="d-flex">
                              <div className="form-check me-2" key={"Yes"}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="IsInActive"
                                  id="rating_1_yes"
                                  value={1}
                                  checked={formData?.IsInActive === 1} // Only true if explicitly 1
                                  onChange={handleChange} // Use `onChange` instead of `onClick`
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="rating_1_yes"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check me-2" key={"No"}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="IsInActive"
                                  id="rating_1_No"
                                  value={0}
                                  checked={formData?.IsInActive === 0} // Only true if explicitly 0
                                  onChange={handleChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="rating_1_No"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-2 text-center">
                      <div>
                        {profilePicError && (
                          <p className="text-danger m-0">{profilePicError}</p>
                        )}
                      </div>
                      <ProfileInput handleProfilePic={handleProfilePic} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Details */}
              <div
                className="tab-pane fade show"
                id="personal"
                role="tabpanel"
                aria-labelledby="personal-tab"
              >
                <div className="container-fluid mt-3">
                  <div className="row">
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">
                          Mobile No. 1 <span className="required">*</span>
                        </label>
                        <input
                          type="number"
                          name="MobileNo1"
                          placeholder="Mobile No. 1"
                          className="form-control"
                          value={formData?.MobileNo1}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.MobileNo1 && (
                          <div className="error">{errors.MobileNo1}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">Mobile No. 2</label>
                        <input
                          type="number"
                          name="MobileNo2"
                          placeholder="Mobile No. 2"
                          className="form-control"
                          value={formData?.MobileNo2}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.MobileNo2 && (
                          <div className="error">{errors.MobileNo2}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">WhatsApp No.</label>
                        <input
                          type="number"
                          name="DeskPhoneNo"
                          placeholder="WhatsApp No."
                          value={formData?.DeskPhoneNo}
                          onChange={(e) => handleChange(e)}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">
                          Emergency Phone No.<span className="required">*</span>
                        </label>

                        <input
                          type="number"
                          placeholder="Phone No."
                          className="form-control"
                          name="EmergencyPhoneNo"
                          value={formData?.EmergencyPhoneNo}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.EmergencyPhoneNo && (
                          <div className="error">{errors.EmergencyPhoneNo}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">
                          Emergency Contact Name
                          <span className="required">*</span>
                        </label>
                        <input
                          placeholder="Contact Name"
                          className="form-control"
                          type="text"
                          name="EmergencyContactName"
                          value={formData?.EmergencyContactName}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.EmergencyContactName && (
                          <div className="error">
                            {errors.EmergencyContactName}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">
                          Contact Relation<span className="required">*</span>
                        </label>
                        <input
                          placeholder="Contact Relation"
                          className="form-control"
                          type="text"
                          name="EmergencyContactRelation"
                          value={formData?.EmergencyContactRelation}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.EmergencyContactRelation && (
                          <div className="error">
                            {errors.EmergencyContactRelation}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">
                          Personal Email<span className="required">*</span>
                        </label>
                        <input
                          placeholder="Personal Email"
                          className="form-control"
                          type="text"
                          name="PersonalEmail"
                          value={formData?.PersonalEmail}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.PersonalEmail && (
                          <div className="error">{errors.PersonalEmail}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">
                          NSS Email <span className="required">*</span>
                        </label>
                        <input
                          placeholder="Official Email"
                          className="form-control"
                          type="text"
                          name="OfficeEmail"
                          value={formData?.OfficeEmail}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.OfficeEmail && (
                          <div className="error">{errors.OfficeEmail}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">Joining Location <span className="required">*</span></label>
                        <input
                          placeholder="Location"
                          className="form-control"
                          type="text"
                          name="Location"
                          value={formData?.Location}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <div className="mt-4">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="IsRemotly"
                              id="IsRemotly"
                              checked={formData?.IsRemotly === "1"}
                              onChange={handleCheckboxChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="IsRemotly"
                            >
                              Is Working Remotely?
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* Correspondence Address Section */}
                    <div className="col-sm-6">
                      <p>
                        <strong>Correspondence Address</strong>
                      </p>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="">
                            <label className="form-label">Address Type</label>
                            <Select
                              isDisabled={true}
                              name="CorrepondenceAddressType"
                              options={[
                                { value: "", label: "Select" },
                                ...addressTypeOptions,
                              ]}
                              value={addressTypeOptions.find(
                                (option) =>
                                  option.value ===
                                  formData?.CorrepondenceAddressType
                              )}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="form-label">
                              Address<span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="CorrespondenceAddress"
                              placeholder="Address"
                              value={formData?.CorrespondenceAddress}
                              onChange={(e) => handleChange(e)}
                            />
                            {errors.CorrespondenceAddress && (
                              <div className="error">
                                {errors.CorrespondenceAddress}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <label className="form-label">
                            Country<span className="required">*</span>
                          </label>
                          <Select
                            type="text"
                            name="CorrespondenceCountry"
                            options={[
                              { value: "", label: "Select" },
                              ...countryOptions,
                            ]}
                            className={` ${errors.CorrespondenceCountry ? "is-invalid" : ""
                              }`}
                            // value={formData.Country}
                            value={countryOptions.find(
                              (option) =>
                                option.value === formData?.CorrespondenceCountry
                            )}
                            onChange={(selectedOption, action) => {
                              handleSelect(selectedOption, action.name);
                            }}
                          />
                          {errors.CorrespondenceCountry && (
                            <div className="error">
                              {errors.CorrespondenceCountry}
                            </div>
                          )}
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">
                            State<span className="required">*</span>
                          </label>
                          <Select
                            type="text"
                            className={` ${errors.CorrespondenceState ? "is-invalid" : ""
                              }`}
                            name="CorrespondenceState"
                            options={[
                              { value: "", label: "Select" },
                              ...stateOptions,
                            ]}
                            value={stateOptions.find(
                              (option) => option.value == formData?.CorrespondenceState
                            ) || null}
                            onChange={(selectedOption, action) => {
                              handleSelect(selectedOption, action.name);
                            }}
                          />
                          {errors.CorrespondenceState && (
                            <div className="error">
                              {errors.CorrespondenceState}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <label className="form-label">
                            City<span className="required">*</span>
                          </label>
                          <Select
                            name="CorrespondenceCity"
                            className={` ${errors.CorrespondenceCity ? "is-invalid" : ""
                              }`}
                            options={[
                              { value: "", label: "Select" },
                              ...cityOptions,
                            ]}
                            value={cityOptions.find(
                              (option) =>
                                option.value === formData?.CorrespondenceCity
                            )|| null}
                            onChange={(selectedOption, action) => {
                              handleSelect(selectedOption, action.name);
                            }}
                          />
                          {errors.CorrespondenceCity && (
                            <div className="error">
                              {errors.CorrespondenceCity}
                            </div>
                          )}
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="form-label">Zip Code</label>
                            <input
                              type="text"
                              className="form-control"
                              name="CorrespondenceZipCode"
                              placeholder="Zipcode"
                              value={formData?.CorrespondenceZipCode}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label className="form-label">Print Address</label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Print Address"
                              name="CorrespondenceAddressPrint"
                              value={formData?.CorrespondenceAddressPrint}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Permanent Address Section */}
                    <div className="col-sm-6">
                      <p className="d-flex gap-1">
                        <strong>Permanent Address</strong>(
                        <div>
                          <div class="form-check">
                            {/* <input
                              class="form-check-input"
                              type="checkbox"
                              name="IsCopyAddress"
                              value="1"
                              id="IsCopyAddress"
                              checked={formData?.IsCopyAddress == 1}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                handleChange(e);
  
                                if (isChecked) {
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    IsCopyAddress: 1, // Ensure checkbox state updates
                                    PermanentAddress:
                                      prevData.CorrespondenceAddress || "",
                                    permanentAddressCountryID:
                                      prevData.CorrespondenceCountry || "",
                                    permanentAddressStateID:
                                      prevData.CorrespondenceState || "",
                                    permanentAddressCityID:
                                      prevData.CorrespondenceCity || "",
                                    permanentAddressZipCode:
                                      prevData.CorrespondenceZip || "",
                                    permanentPrintAddress:
                                      prevData.CorrespondenceAddressPrint || "",
                                  }));
                                } else {
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    IsCopyAddress: 0,
                                    PermanentAddress: "",
                                    permanentAddressCountryID: "",
                                    permanentAddressStateID: "",
                                    permanentAddressCityID: "",
                                    permanentAddressZipCode: "",
                                    permanentPrintAddress: "",
                                  }));
                                }
                              }}
                            /> */}
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="IsCopyAddress"
                              value="1"
                              id="IsCopyAddress"
                              checked={formData?.IsCopyAddress == 1}
                              onChange={(e) => {
                                const isChecked = e.target.checked;

                                // Validation: Check if correspondence address and city are provided
                                if (
                                  isChecked &&
                                  (!formData?.CorrespondenceAddress ||
                                    !formData?.CorrespondenceCity)
                                ) {
                                  toast.error(
                                    "Please enter First Correspondence Address"
                                  );
                                  return;
                                }

                                handleChange(e);

                                if (isChecked) {
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    IsCopyAddress: 1, // Ensure checkbox state updates
                                    permanentAddressCode:
                                      prevData.CorrespondenceAddress || "",
                                    permanentAddressCountryID:
                                      prevData.CorrespondenceCountry || "",
                                    permanentAddressStateID:
                                      prevData.CorrespondenceState || "",
                                    permanentAddressCityID:
                                      prevData.CorrespondenceCity || "",
                                    permanentAddressZipCode:
                                      prevData.CorrespondenceZipCode || "",
                                    permanentPrintAddress:
                                      prevData.CorrespondenceAddressPrint || "",
                                  }));
                                } else {
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    IsCopyAddress: 0,
                                    permanentAddressCode: "",
                                    permanentAddressCountryID: "",
                                    permanentAddressStateID: "",
                                    permanentAddressCityID: "",
                                    permanentAddressZipCode: "",
                                    permanentPrintAddress: "",
                                  }));
                                }
                              }}
                            />

                            <label class="form-check-label" for="IsCopyAddress">
                              Is Same as Correspondence Address?)
                            </label>
                          </div>
                        </div>
                      </p>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="">
                            <label className="form-label">Address Type</label>
                            <Select
                              isDisabled={true}
                              name="PermanentAddressType"
                              options={[
                                { value: "", label: "Select" },
                                ...addressTypeOptions,
                              ]}
                              value={addressTypeOptions.find(
                                (option) =>
                                  option.value ===
                                  formData?.PermanentAddressType
                              )}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="form-label">Address</label>
                            <input
                              type="text"
                              name="permanentAddressCode"
                              value={formData?.permanentAddressCode}
                              className="form-control"
                              onChange={(e) => handleChange(e)}
                              placeholder="Address"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <label className="form-label">Country</label>
                          <Select
                            type="text"
                            name="permanentAddressCountryID"
                            options={[
                              { value: "", label: "Select" },
                              ...countryOptions,
                            ]}
                            value={countryOptions.find(
                              (option) =>
                                option.value ===
                                formData?.permanentAddressCountryID
                            )}
                            onChange={(selectedOption, action) => {
                              handleSelect(selectedOption, action.name);
                            }}
                          />
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">State</label>
                          <Select
                            type="text"
                            options={[
                              { value: "", label: "Select" },
                              ...stateOptions,
                            ]}
                            value={stateOptions.find(
                              (option) =>
                                option.value ===
                                formData?.permanentAddressStateID
                            )}
                            name="permanentAddressStateID"
                            onChange={(selectedOption, action) => {
                              handleSelect(selectedOption, action.name);
                            }}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <label className="form-label">City</label>
                          <Select
                            name="permanentAddressCityID"
                            options={[
                              { value: "", label: "Select" },
                              ...cityOptions,
                            ]}
                            value={cityOptions.find(
                              (option) =>
                                option.value ===
                                formData?.permanentAddressCityID
                            )}
                            onChange={(selectedOption, action) => {
                              handleSelect(selectedOption, action.name);
                            }}
                          />
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="form-label">Zip Code</label>
                            <input
                              type="text"
                              className="form-control"
                              name="permanentAddressZipCode"
                              value={formData?.permanentAddressZipCode}
                              onChange={(e) => handleChange(e)}
                              placeholder="Zipcode"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label className="form-label">Print Address</label>
                            <input
                              className="form-control"
                              type="text"
                              name="permanentPrintAddress"
                              placeholder="Print Address"
                              onChange={(e) => handleChange(e)}
                              value={formData?.permanentPrintAddress}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bank Details */}
              <div
                className="tab-pane fade show"
                id="project"
                role="tabpanel"
                aria-labelledby="project-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "employeebank",
                                initialFormData?.employeebank,
                                "PayTo"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <Table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "15%" }}>Pay To</th>
                                <th style={{ width: "15%" }}>
                                  Bank<span className="required">*</span>
                                </th>
                                <th style={{ width: "15%" }}>
                                  Branch
                                  {/* <span className="required">*</span> */}
                                </th>
                                <th style={{ width: "15%" }}>
                                  Account No.<span className="required">*</span>
                                </th>
                                <th style={{ width: "15%" }}>
                                  IFSC Code<span className="required">*</span>
                                </th>
                                <th
                                  style={{
                                    width: "5%",
                                    textAlign: "center",
                                  }}
                                >
                                  Default
                                </th>
                                <th style={{ width: "5%" }}>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.employeebank &&
                                formData.employeebank.map &&
                                formData.employeebank.map((line, index) => (
                                  <tr>
                                    <td>
                                      <input
                                        type="text"
                                        placeholder="In case of contractor"
                                        className="form-control"
                                        name="PayTo"
                                        value={`${formData.FirstName || ""} ${formData.LastName || ""
                                          }`.trim()}
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeebank"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <Select
                                        menuPlacement="top"
                                        styles={tableSelectStyle}
                                        menuPortalTarget={document.body}
                                        name="Bank"
                                        // className={`form-control${
                                        //   errors?.[`employeebank[${index}].Bank`]
                                        //     ? "is-invalid"
                                        //     : ""
                                        // }`}
                                        value={bankOptions?.find(
                                          (option) =>
                                            option.value ===
                                            formData?.employeebank[index]?.Bank
                                        )}
                                        options={[
                                          { value: "", label: "Select" },
                                          ...bankOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "employeebank"
                                          )
                                        }
                                      />
                                      {errors[
                                        `employeebank[${index}].Bank`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `employeebank[${index}].Bank`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        placeholder="Branch"
                                        className={`form-control ${errors?.[
                                          `employeebank[${index}].Branch`
                                        ]
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        name="Branch"
                                        value={
                                          formData.employeebank?.[index].Branch
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeebank"
                                          )
                                        }
                                      />
                                      {errors[
                                        `employeebank[${index}].Branch`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `employeebank[${index}].Branch`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        placeholder="Account No"
                                        className={`form-control text-end${errors?.[
                                          `employeebank[${index}].AccountNo`
                                        ]
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        name="AccountNo"
                                        value={
                                          formData.employeebank[index].AccountNo
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeebank"
                                          )
                                        }
                                        onKeyDown={(e) => {
                                          if (
                                            ["e", "E", "+", "-", "."].includes(
                                              e.key
                                            )
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                      {errors[
                                        `employeebank[${index}].AccountNo`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `employeebank[${index}].AccountNo`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        placeholder="IFSC Code"
                                        className={`form-control text-end${errors?.[
                                          `employeebank[${index}].IFSCCode`
                                        ]
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        name="IFSCCode"
                                        value={
                                          formData.employeebank[index].IFSCCode
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeebank"
                                          )
                                        }
                                      />
                                      {errors[
                                        `employeebank[${index}].IFSCCode`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `employeebank[${index}].IFSCCode`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td className="text-center align-middle">
                                      <input
                                        class="form-check-input"
                                        type="checkbox"
                                        value="1"
                                        name="DefaultBank"
                                        id="DefaultBank"
                                        checked={
                                          formData.employeebank[index]
                                            .DefaultBank == 1
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeebank"
                                          )
                                        }
                                      />
                                    </td>
                                    <td className="text-center align-middle">
                                      <a
                                        // onClick={(e) =>
                                        //     handleChangeWithIndex(
                                        //         e,
                                        //         "remove",
                                        //         "employeebank",
                                        //         index,
                                        //         ""
                                        //     )
                                        // }

                                        onClick={(e) =>
                                          deleteLine(
                                            e,
                                            "employeebank",
                                            line.LineNo
                                          )
                                        }
                                        className=""
                                      >
                                        <i className="bi bi-trash"></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Tax Detail */}
              {/* <div
                className="tab-pane fade show"
                id="rating"
                role="tabpanel"
                aria-labelledby="rating-tab"
              >
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-2 form-group">
                      <label className="form-label">
                        GSTNo/UIN<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="GSTNo"
                        value={formData.GSTNo}
                        className={"form-control"}
                        placeholder="GSTNo"
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2 form-group">
                      <label className="form-label">VAT/TIN</label>
                      <input
                        type="text"
                        name="VATNo"
                        value={formData.VATNo}
                        className={"form-control"}
                        placeholder="VATNo"
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2 form-group">
                      <label className="form-label">CST No.</label>
                      <input
                        type="text"
                        name="CSTNo"
                        value={formData?.CSTNo}
                        className="form-control"
                        placeholder="CST No."
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2 form-group">
                      <label className="form-label">
                        PAN No.<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="PANNo"
                        value={formData.PANNo}
                        className="form-control"
                        placeholder="PAN No."
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">GST Date</label>
                      <CustomDatePicker
                        name="GSTEffectiveDate"
                        id="GSTEffectiveDate"
                        className="form-control"
                        placeholderText="DD-MMM-YYYY"
                        value={formData?.GSTEffectiveDate}
                        handleChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">VAT Date</label>
                      <CustomDatePicker
                        name="VATEffectiveDate"
                        id="VATEffectiveDate"
                        className="form-control"
                        placeholderText="DD-MMM-YYYY"
                        value={formData?.VATEffectiveDate}
                        handleChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">CST Date</label>
                      <CustomDatePicker
                        name="CSTEffectiveDate"
                        id="CSTEffectiveDate"
                        className="form-control"
                        placeholderText="DD-MMM-YYYY"
                        value={formData?.CSTEffectiveDate}
                        handleChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2 form-group">
                      <label className="form-label">Service Tax No.</label>
                      <input
                        type="text"
                        name="STNo"
                        id="STNo"
                        className="form-control"
                        placeholder="Service Tax No."
                        value={formData?.STNo}
                        handleChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">GST Reg. Type</label>
                      <Select
                        options={[
                          { value: "", label: "Select" },
                          ...gstRegTypeOptions,
                        ]}
                        name="GSTRegistrationType_192"
                        value={gstRegTypeOptions.find(
                          (option) =>
                            option.value === formData?.GSTRegistrationType_192
                        )}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        isDisabled={!formData.GSTNo || !!errors.GSTNo}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">Service Tax Date</label>
                      <CustomDatePicker
                        name="STEffectiveDate"
                        id="STEffectiveDate"
                        placeholderText="DD-MMM-YYYY"
                        className="form-control"
                        value={formData?.STEffectiveDate}
                        handleChange={(e) => handleChange(e)}
                      />
                    </div>
                  </div>
                </div>
              </div> */}
              {/* HR Details */}
              <div
                className="tab-pane fade show"
                id="other"
                role="tabpanel"
                aria-labelledby="other-tab"
              >
                <div className="container-fluid mt-3">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-2">
                          <label className="form-label">Working Status</label>
                          <Select
                            options={[
                              { value: "", label: "Select" },
                              ...workingStatusOptions,
                            ]}
                            // value={formData?.WorkingStatus}
                            value={workingStatusOptions.find(
                              (option) =>
                                option.value === formData?.WorkingStatus
                            )}
                            name="WorkingStatus"
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                          />
                        </div>
                        <div className="col-md-2">
                          <label className="form-label">
                            Leave Accrual Type
                          </label>
                          <Select
                            options={[
                              { value: "", label: "Select" },
                              ...leaveAcuralOptions,
                            ]}
                            value={titleOptions.find(
                              (option) =>
                                option.value === formData?.LeaveAccrualType_155
                            )}
                            name="LeaveAccrualType_155"
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                          />
                        </div>
                        <div className="col-sm-2">
                          <label className="form-label">Referred By</label>
                          <Select
                            options={[
                              { value: "", label: "Select" },
                              ...referedByOptions,
                            ]}
                            value={referedByOptions.find(
                              (option) => option.value === formData?.ReferBy
                            )}
                            name="ReferBy"
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                          />
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label className="form-label">
                              Resignation Date
                            </label>
                            <CustomDatePicker
                              name="ResignationDate"
                              id="ResignationDate"
                              placeholderText="DD-MMM-YYYY"
                              className="form-control"
                              value={formData?.ResignationDate}
                              handleChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label className="form-label">
                              Resg. Acceptance Date
                            </label>
                            <CustomDatePicker
                              name="ConfirmationDate"
                              id="ConfirmationDate"
                              placeholderText="DD-MMM-YYYY"
                              className="form-control"
                              value={formData.ConfirmationDate}
                              handleChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label className="form-label">Relieving Date</label>
                            <CustomDatePicker
                              name="RelivingDate"
                              id="RelivingDate"
                              placeholderText="DD-MMM-YYYY"
                              className="form-control"
                              value={formData?.RelivingDate}
                              handleChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <label className="form-label">Relieving Type</label>
                          <Select
                            options={[
                              { value: "", label: "Select" },
                              ...relievingTypeOptions,
                            ]}
                            name="RelivingType_119"
                            value={relievingTypeOptions.find(
                              (option) =>
                                option.value === formData?.RelivingType_119
                            )}
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                          />
                        </div>
                         <div className="col-sm-2">
                          <label className="form-label">Band<span className="required">*</span></label>
                          <Select
                            options={[
                              { value: "", label: "Select" },
                              ...brandTypeOptions,
                            ]}
                            name="BandType_2015"
                            value={brandTypeOptions.find(
                              (option) =>
                                option.value === formData?.BandType_2015
                            )}
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                          />
                           {errors.BandType_2015 && (
                          <div className="error">{errors.BandType_2015}</div>
                        )}
                        </div>
                        <div className="col-sm-2">
                          <label className="form-label">Sub Band<span className="required">*</span></label>
                          <Select
                            options={[
                              { value: "", label: "Select" },
                              ...subrandTypeOptions,
                            ]}
                            name="SubBandType_2015"
                            value={subrandTypeOptions.find(
                              (option) =>
                                option.value === formData?.SubBandType_2015
                            )}
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                          />
                           {errors.SubBandType_2015 && (
                          <div className="error">{errors.SubBandType_2015}</div>
                        )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <strong>Employee History</strong>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "employeeDetails",
                                initialFormData?.employeeDetails,
                                "branch"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <hr />
                        <div className="table-responsive poc-head rounded">
                          <Table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "12%" }}>
                                  Branch<span className="required">*</span>
                                </th>
                                <th style={{ width: "12%" }}>
                                  Shift<span className="required">*</span>
                                </th>
                                <th style={{ width: "15%" }}>
                                  Department<span className="required">*</span>
                                </th>
                                <th style={{ width: "15%" }}>
                                  Sub Department
                                </th>
                                <th style={{ width: "13%" }}>
                                  Designation<span className="required">*</span>
                                </th>
                                <th style={{ width: "19%" }}>
                                  Immediate Superior
                                  <span className="required">*</span>
                                </th>
                                <th style={{ width: "14%" }}>
                                  From Date<span className="required">*</span>
                                </th>
                                <th style={{ width: "15%" }}>To Date</th>
                                <th style={{ width: "3%" }}>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.employeeDetails &&
                                formData.employeeDetails.map &&
                                formData.employeeDetails.map((line, index) => (
                                  <tr>
                                    <td>
                                      <Select
                                        name="Branch"
                                        value={branchOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.employeeDetails[index]
                                              .Branch
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...branchOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "employeeDetails"
                                          )
                                        }
                                      />{" "}
                                      {errors[
                                        `employeeDetails[${index}].Branch`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `employeeDetails[${index}].Branch`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <Select
                                        name="ShiftID"
                                        value={shiftsOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.employeeDetails[index]
                                              .ShiftID
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...shiftsOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "employeeDetails"
                                          )
                                        }
                                      />
                                      {errors[
                                        `employeeDetails[${index}].ShiftID`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `employeeDetails[${index}].ShiftID`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <Select
                                        name="DepartmentID"
                                        value={departmentOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.employeeDetails[index].DepartmentID
                                        )}
                                        onChange={(selectedOption, action) => {
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "employeeDetails"
                                          );

                                          handleLineSelect(
                                            { value: "", label: "Select" },
                                            "SubDepartmentID",
                                            index,
                                            "employeeDetails"
                                          );

                                          // FETCH new sub departments
                                          if (selectedOption?.value) {
                                            fetchSubDepartment(selectedOption.value);
                                          } else {
                                            setSubDepartmentOptions([]);
                                          }
                                        }}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...departmentOptions,
                                        ]}
                                      />

                                      {errors[
                                        `employeeDetails[${index}].DepartmentID`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `employeeDetails[${index}].DepartmentID`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <Select
                                        name="SubDepartmentID"
                                        value={subDepartmentOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.employeeDetails[index].SubDepartmentID
                                        )}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "employeeDetails"
                                          )
                                        }
                                        isDisabled={
                                          formData.employeeDetails[index].canBeDisabled === 1
                                        }
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...subDepartmentOptions,
                                        ]}
                                      />

                                      {errors[
                                        `employeeDetails[${index}].SubDepartmentID`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `employeeDetails[${index}].SubDepartmentID`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip
                                          id={`tooltip-designation-${index}`}
                                        >
                                          {designationOptions.find(
                                            (option) =>
                                              option.value ===
                                              formData.employeeDetails[index]
                                                .DesignationID
                                          )?.label || "No designation selected"}
                                        </Tooltip>
                                      }
                                    >
                                      <td>
                                        <Select
                                          name="DesignationID"
                                          value={designationOptions.find(
                                            (option) =>
                                              option.value ===
                                              formData.employeeDetails[index]
                                                .DesignationID
                                          )}
                                          menuPortalTarget={document.body}
                                          styles={tableSelectStyle}
                                          menuPlacement="top"
                                          options={[
                                            { value: "", label: "Select" },
                                            ...designationOptions,
                                          ]}
                                          onChange={(selectedOption, action) =>
                                            handleLineSelect(
                                              selectedOption,
                                              action.name,
                                              index,
                                              "employeeDetails"
                                            )
                                          }
                                        />
                                        {errors[
                                          `employeeDetails[${index}].DesignationID`
                                        ] && (
                                            <span className="error">
                                              {
                                                errors[
                                                `employeeDetails[${index}].DesignationID`
                                                ]
                                              }
                                            </span>
                                          )}
                                      </td>
                                    </OverlayTrigger>
                                    <td>
                                      <Select
                                        name="ImmediateSuperiorID"
                                        value={immediateSuperiorOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.employeeDetails[index]
                                              .ImmediateSuperiorID
                                        )}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "employeeDetails"
                                          )
                                        }
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...immediateSuperiorOptions,
                                        ]}
                                      />
                                      {errors[
                                        `employeeDetails[${index}].ImmediateSuperiorID`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `employeeDetails[${index}].ImmediateSuperiorID`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        required={true}
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeeDetails"
                                          )
                                        }
                                        // index={index}
                                        module="employeeDetails"
                                        name="FromDate"
                                        value={
                                          formData.employeeDetails[index]
                                            .FromDate
                                        }
                                      />
                                      {errors[
                                        `employeeDetails[${index}].FromDate`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `employeeDetails[${index}].FromDate`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        required={true}
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeeDetails"
                                          )
                                        }
                                        // index={index}
                                        module="employeeDetails"
                                        name="ToDate"
                                        value={
                                          formData.employeeDetails[index].ToDate
                                        }
                                      />
                                    </td>
                                    <td className="text-center align-middle">
                                      <a
                                        // onClick={(e) =>
                                        //     handleChangeWithIndex(
                                        //         e,
                                        //         "remove",
                                        //         "employeeDetails",
                                        //         index,
                                        //         ""
                                        //     )
                                        // }

                                        onClick={(e) =>
                                          deleteLine(
                                            e,
                                            "employeeDetails",
                                            line.LineNo
                                          )
                                        }
                                        className=""
                                      >
                                        <i className="bi bi-trash"></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Working Areas */}
              <div
                className="tab-pane fade show"
                id="areas"
                role="tabpanel"
                aria-labelledby="areas-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "workingarea",
                                initialFormData?.workingarea,
                                "EmployeeType_069"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <Table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "32%" }}>
                                  Employee Type
                                  {/* <span className="required">*</span> */}
                                </th>
                                <th style={{ width: "32%" }}>
                                  Branch
                                  {/* <span className="required">*</span> */}
                                </th>
                                <th style={{ width: "32%" }}>Company</th>
                                <th style={{ width: "4%" }}>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.workingarea &&
                                formData.workingarea.map &&
                                formData.workingarea.map((line, index) => (
                                  <tr>
                                    <td>
                                      <Select
                                        className={
                                          // errors?.workingarea?.[index]
                                          //     ?.EmployeeType_069?.status
                                          //     ? "is-invalid"
                                          //     :
                                          ""
                                        }
                                        name="EmployeeType_069"
                                        // value={
                                        //   formData.workingarea[index]
                                        //     .EmployeeType_069
                                        // }
                                        value={employeeTypeOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.workingarea[index]
                                              .EmployeeType_069
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...employeeTypeOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "workingarea"
                                          )
                                        }
                                      />
                                      {errors[
                                        `workingarea[${index}].EmployeeType_069`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `workingarea[${index}].EmployeeType_069`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <Select
                                        className={
                                          // errors?.workingarea?.[index]
                                          //     ?.EmployeeType_069?.status
                                          //     ? "is-invalid"
                                          //     :
                                          ""
                                        }
                                        name="Branch"
                                        // value={formData.workingarea[index].branch}
                                        value={branchOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.workingarea[index].Branch
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...branchOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "workingarea"
                                          )
                                        }
                                      />
                                      {errors[
                                        `workingarea[${index}].Branch`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `workingarea[${index}].Branch`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <Select
                                        className={
                                          // errors?.workingarea?.[index]
                                          //     ?.EmployeeType_069?.status
                                          //     ? "is-invalid"
                                          //     :
                                          ""
                                        }
                                        name="Company"
                                        // value={
                                        //     formData.workingarea[index]
                                        //         .company
                                        // }
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "workingarea"
                                          )
                                        }
                                        value={companyOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.workingarea[index].Company
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...companyOptions,
                                        ]}
                                      />
                                      {/* {errors?.workingarea?.[index]
                                                                              ?.company?.status && (
                                                                                  <span className="error">
                                                                                      {" "}
                                                                                      {
                                                                                          errors?.workingarea?.[index]
                                                                                              ?.company?.message
                                                                                      }
                                                                                  </span>
                                                                              )} */}
                                    </td>

                                    <td className="text-center align-middle">
                                      <a
                                        // onClick={(e) =>
                                        //     handleChangeWithIndex(
                                        //         e,
                                        //         "remove",
                                        //         "workingarea",
                                        //         index,
                                        //         ""
                                        //     )
                                        // }
                                        onClick={(e) =>
                                          deleteLine(
                                            e,
                                            "workingarea",
                                            line.LineNo
                                          )
                                        }
                                        className=""
                                      >
                                        <i className="bi bi-trash"></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Location History */}
              <div
                className="tab-pane fade show"
                id="locationhistory"
                role="tabpanel"
                aria-labelledby="locationhistory-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "empLocation",
                                initialFormData?.empLocation,
                                "CityID"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "30%" }}>
                                  City

                                </th>
                                <th style={{ width: "30%" }}>From Date</th>
                                <th style={{ width: "30%" }}>To Date</th>
                                <th style={{ width: "10%" }}>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.empLocation &&
                                formData.empLocation.map &&
                                formData.empLocation.map((line, index) => (
                                  <tr>
                                    <td>
                                      <Select
                                        name="CityID"
                                        value={cityIDOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.empLocation[index].CityID
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="bottom"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...cityIDOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "empLocation"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        required={true}
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "empLocation"
                                          )
                                        }
                                        // index={index}
                                        module="empLocation"
                                        name="FromDate"
                                        value={
                                          formData.empLocation[index].FromDate
                                        }
                                      />
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        required={true}
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "empLocation"
                                          )
                                        }
                                        // index={index}
                                        module="empLocation"
                                        name="ToDate"
                                        value={
                                          formData.empLocation[index].ToDate
                                        }
                                      />
                                    </td>
                                    <td className="text-center align-middle">
                                      <a
                                        onClick={(e) =>
                                          deleteLine(
                                            e,
                                            "empLocation",
                                            line.LineNo
                                          )
                                        }
                                        className={
                                          line.isDelete
                                            ? "text-danger"
                                            : "text-muted"
                                        }
                                      >
                                        <i
                                          className={`bi bi-trash icons${line.isDelete ? "" : "disabled-icon"
                                            }`}
                                        ></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Employee Attachment */}
              <div
                className="tab-pane fade show"
                id="attachment"
                role="tabpanel"
                aria-labelledby="attachment-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <span className="pull-right">
                            {" "}
                            Max 5 MB | Allowed: PDF, JPG, PNG &nbsp;
                            <FileUploader handleFile={handleFile} />
                          </span>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "40%" }}>File Name</th>
                                <th style={{ width: "40%" }}>File Size</th>
                                <th style={{ width: "20%" }}>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.files.map((file, index) => (
                                <tr key={index}>
                                  {/* <td>{file.name}</td>*/}
                                  <td>
                                    <a
                                      href={URL.createObjectURL(file)}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {file.name}
                                    </a>
                                  </td>

                                  {/* Now showing the file name correctly */}
                                  <td className="text-center">
                                    {formData.filesize[index]}
                                  </td>
                                  <td className="text-center align-middle">
                                    {/* <a
                                      onClick={() => removeFile(index)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <i className="bi bi-trash text-info"></i>
                                    </a> */}
                                    <a
                                      onClick={(e) => {
                                        e.preventDefault(); // Prevent default anchor behavior
                                        e.stopPropagation(); // Prevent event bubbling
                                        removeFile(index);
                                      }}
                                      className=" cursor-pointer" // Add pointer cursor and red color
                                      title="Delete file"
                                    >
                                      <i className="bi bi-trash"></i>
                                    </a>
                                  </td>
                                </tr>
                              ))}
                            </tbody>

                            {/* <tbody>
                              {formData.files.map((file, index) => (
                                <tr key={index}>
                                  <td>{file}</td>
                                  <td className="text-center">
                                    {formData.filesize[index]}
                                  </td>
                                  <td className="text-center align-middle">
                                    <a
                                      onClick={() => removeFile(index)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <i className="bi bi-trash"></i>
                                    </a>
                                  </td>
                                </tr>
                              ))}
                            </tbody> */}
                          </table>
                          <div className="attach_msg">
                            Note:
                            <ul>
                              <li>
                                Please attach all relevant supporting documents.
                              </li>
                              <li>
                                File Naming Format: YourName_FileName.extension (e.g., JohnDoe_Resume.pdf, JohnDoe_10thMarkSheet.pdf).
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* qualification */}
              <div
                className="tab-pane fade show"
                id="qualification"
                role="tabpanel"
                aria-labelledby="qualification-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "qualification",
                                initialFormData?.qualification,
                                "QualificationType"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "15%" }}>
                                  Qualification Type
                                  <span className="text-danger">*</span>
                                </th>
                                <th style={{ width: "10%" }}>Qualification</th>
                                <th style={{ width: "10%" }}>Stream</th>
                                <th style={{ width: "20%" }}>Institute</th>
                                <th style={{ width: "12%" }}>Percentage / CGPA</th>
                                <th style={{ width: "15%" }}>
                                  Year Of Passing
                                </th>
                                <th style={{ width: "10%" }}>University</th>
                                <th style={{ width: "11%" }}>File</th>
                                <th style={{ width: "8%" }}>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.qualification &&
                                formData.qualification.map &&
                                formData.qualification.map((line, index) => (
                                  <tr>
                                    <td>
                                      <input
                                        className="form-control"
                                        placeholder="qualification Type"
                                        name="QualificationType"
                                        value={
                                          formData.qualification[index]
                                            .QualificationType
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                      {errors[
                                        `qualification[${index}].QualificationType`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `qualification[${index}].QualificationType`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <input
                                        className={"form-control"}
                                        placeholder="qualification"
                                        name="Qualification"
                                        value={
                                          formData.qualification[index]
                                            .Qualification
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                      {errors[
                                        `qualification[${index}].Qualification`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `qualification[${index}].Qualification`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <input
                                        className="form-control"
                                        placeholder="Stream"
                                        name="Stream"
                                        value={
                                          formData.qualification[index].Stream
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        className="form-control"
                                        placeholder="Institute"
                                        name="Institute"
                                        value={
                                          formData.qualification[index]
                                            .Institute
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        className="form-control text-end"
                                        placeholder="%"
                                        name="Percentage"
                                        value={
                                          formData.qualification[index]
                                            .Percentage
                                        }
                                        onKeyDown={(e) => {
                                          if (
                                            ["e", "E", "+", "-", "."].includes(
                                              e.key
                                            )
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        className={"form-control text-end"}
                                        placeholder="Year Of Passing"
                                        name="YearOfPassing"
                                        value={
                                          formData.qualification[index]
                                            .YearOfPassing
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        className={"form-control"}
                                        placeholder="University"
                                        name="University"
                                        value={
                                          formData.qualification[index]
                                            .University
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                    </td>
                                    {/* for file upload & view */}
                                    <td className="text-center align-middle">
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        <label
                                          htmlFor={`qual-file-${index}`}
                                          title="Upload File"
                                          style={{ cursor: "pointer", margin: 0 }}
                                        >
                                          <i
                                            className="fa fa-cloud-upload"
                                            style={{
                                              fontSize: "14px",
                                              color: "#27568B",
                                            }}
                                          />
                                        </label>
                                        <input
                                          id={`qual-file-${index}`}
                                          type="file"
                                          accept=".jpg,.jpeg,.png,.pdf"
                                          onChange={(e) =>
                                            handleQualFileChange(e.target.files, index)
                                          }
                                          style={{ display: "none" }}
                                        />
                                        {(formData.qualification[index]?.QualificationFilePreview || formData.qualification[index]?.QualificationFile || line?.QualificationFile) && (
                                          <a
                                            href={
                                              formData.qualification[index]?.QualificationFilePreview ||
                                              (typeof formData.qualification[index]?.QualificationFile === "string" ? formData.qualification[index].QualificationFile : "")
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="View File"
                                          >
                                            <i
                                              className="fa fa-eye"
                                              style={{
                                                fontSize: "14px",
                                                color: "#27568B",
                                                cursor: "pointer",
                                              }}
                                            />
                                          </a>
                                        )}
                                      </div>
                                    </td>
                                    <td className="text-center align-middle">
                                      <a
                                        onClick={(e) =>
                                          deleteLine(
                                            e,
                                            "qualification",
                                            line.LineNo
                                          )
                                        }
                                        className=""
                                      >
                                        <i className="bi bi-trash"></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Employee identities */}
              <div
                className="tab-pane fade show"
                id="identities"
                role="tabpanel"
                aria-labelledby="identities-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "identities",
                                initialFormData?.identities,
                                "IdentityType_063"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "13%" }}>
                                  Identity Type
                                  <span className="required">*</span>
                                </th>
                                <th style={{ width: "18%" }}>
                                  Name On Identity
                                  <span className="required">*</span>
                                </th>
                                <th style={{ width: "14%" }}>
                                  Identity No.
                                  <span className="required">*</span>
                                </th>
                                <th style={{ width: "13%" }}>
                                  Issuing Country
                                  <span className="required">*</span>
                                </th>
                                <th style={{ width: "13%" }}>Issue Date</th>
                                <th style={{ width: "13%" }}>Expiry Date</th>
                                <th style={{ width: "6%" }}>File</th>
                                <th style={{ width: "6%" }}>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.identities &&
                                formData.identities.map &&
                                formData.identities.map((line, index) => (
                                  <tr>
                                    <td>
                                      <Select
                                        name="IdentityType_063"
                                        value={identityTypeOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.identities[index]
                                              .IdentityType_063
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...identityTypeOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "identities"
                                          )
                                        }
                                      />
                                      {errors[
                                        `identities[${index}].IdentityType_063`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `identities[${index}].IdentityType_063`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <input
                                        className={
                                          // errors?.identities?.[index]?.NameOnIdentity
                                          //     ?.status
                                          //     ? "is-invalid form-control"
                                          //     :
                                          "form-control"
                                        }
                                        placeholder="Name as per identity"
                                        name="NameOnIdentity"
                                        value={
                                          formData.identities[index]
                                            .NameOnIdentity
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "identities"
                                          )
                                        }
                                      />
                                      {errors[
                                        `identities[${index}].NameOnIdentity`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `identities[${index}].NameOnIdentity`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <input
                                        className={
                                          // errors?.identities?.[index]
                                          //     ?.Number?.status
                                          //     ? "is-invalid form-control"
                                          //     :
                                          "form-control"
                                        }
                                        placeholder="No"
                                        name="IdentityNo"
                                        value={
                                          formData.identities[index].IdentityNo
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "identities"
                                          )
                                        }
                                      />
                                      {errors[
                                        `identities[${index}].IdentityNo`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `identities[${index}].IdentityNo`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <Select
                                        name="IssuingCountry"
                                        // value={
                                        //     formData.identities[index].IssuingCountry
                                        // }
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...identityIssueingOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "identities"
                                          )
                                        }
                                      />
                                      {errors[
                                        `identities[${index}].IssuingCountry`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `identities[${index}].IssuingCountry`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      {/* <CustomDatePicker
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "identities"
                                          )
                                        }
                                        index={index}
                                        module="identities"
                                        name="IssueDate"
                                        value={
                                            formData.identities[index]
                                                .IssueDate
                                        }
                                      /> */}
                                      <CustomDatePicker
                                        required={true}
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "identities"
                                          )
                                        }
                                        // index={index}
                                        module="identities"
                                        name="IssueDate"
                                        value={
                                          formData.identities[index].IssueDate
                                        }
                                      />
                                      {errors[
                                        `identities[${index}].IssueDate`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `identities[${index}].IssueDate`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      {/* <CustomDatePicker
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "identities"
                                          )
                                        }
                                        index={index}
                                        module="identities"
                                        name="ExpiryDate"
                                        value={
                                            formData.identities[index]
                                                .ExpiryDate
                                        }
                                      /> */}
                                      <CustomDatePicker
                                        required={true}
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "identities"
                                          )
                                        }
                                        // index={index}
                                        module="identities"
                                        name="ExpiryDate"
                                        value={
                                          formData.identities[index].ExpiryDate
                                        }
                                      />
                                    </td>
                                    {/* for file upload  */}
                                    <td className="text-center">
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          gap: "10px",
                                          marginTop: "10px",
                                        }}
                                      >
                                        {/* Upload Icon */}
                                        <label
                                          htmlFor={`identity-file-${index}`}
                                          title="Upload File"
                                          style={{ cursor: "pointer", margin: 0 }}
                                        >
                                          <i
                                            className="fa fa-cloud-upload"
                                            style={{
                                              fontSize: "14px",
                                              color: "#27568B",
                                            }}
                                          />
                                        </label>

                                        <input
                                          id={`identity-file-${index}`}
                                          type="file"
                                          accept=".jpg,.jpeg,.png,.pdf"
                                          onChange={(e) =>
                                            handleIdentityFileChange(e.target.files, index)
                                          }
                                          style={{ display: "none" }}
                                        />

                                        {/* View Icon */}
                                        {formData.identities[index]?.IdentityFilePreview && (
                                          <a
                                            href={formData.identities[index].IdentityFilePreview}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="View File"
                                          >
                                            <i
                                              className="fa fa-eye"
                                              style={{
                                                fontSize: "14px",
                                                color: "#27568B",
                                                cursor: "pointer",
                                              }}
                                            />
                                          </a>
                                        )}
                                      </div>
                                    </td>
                                    <td className="text-center align-middle">
                                      <a
                                        onClick={(e) =>
                                          deleteLine(
                                            e,
                                            "identities",
                                            line.LineNo
                                          )
                                        }
                                        className=""
                                      >
                                        <i className="bi bi-trash"></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Employment Details */}
              <div
                className="tab-pane fade show"
                id="employmentdetails"
                role="tabpanel"
                aria-labelledby="employmentdetails-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            type="button"
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "employment_history",
                                {
                                  OrganizationName: "",
                                  Location: "",
                                  StartDate: "",
                                  EndDate: "",
                                  Position: "",
                                  OfferLetter: "",
                                  SalarySlip: "",
                                  RelievingLetter: "",
                                },
                                "OrganizationName"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <table id="poctable_head" className="table table-bordered">
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "18%" }}>Organization Name</th>
                                <th style={{ width: "12%" }}>Location</th>
                                <th style={{ width: "12%" }}>Start Date</th>
                                <th style={{ width: "12%" }}>End Date</th>
                                <th style={{ width: "14%" }}>Position</th>
                                <th style={{ width: "8%" }}>Offer Letter</th>
                                <th style={{ width: "8%" }}>Salary Slip</th>
                                <th style={{ width: "10%" }}>Relieving & Exp.</th>
                                <th style={{ width: "6%" }}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.employment_history &&
                                formData.employment_history.map((line, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        className="form-control"
                                        placeholder="Organization Name"
                                        name="OrganizationName"
                                        value={line.OrganizationName || ""}
                                        onChange={(e) =>
                                          handleAllLineChange(e, index, "employment_history")
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        className="form-control"
                                        placeholder="Location"
                                        name="Location"
                                        value={line.Location || ""}
                                        onChange={(e) =>
                                          handleAllLineChange(e, index, "employment_history")
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="date"
                                        className="form-control"
                                        name="StartDate"
                                        value={line.StartDate || ""}
                                        onChange={(e) =>
                                          handleAllLineChange(e, index, "employment_history")
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="date"
                                        className="form-control"
                                        name="EndDate"
                                        value={line.EndDate || ""}
                                        onChange={(e) =>
                                          handleAllLineChange(e, index, "employment_history")
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        className="form-control"
                                        placeholder="Position"
                                        name="Position"
                                        value={line.Position || ""}
                                        onChange={(e) =>
                                          handleAllLineChange(e, index, "employment_history")
                                        }
                                      />
                                    </td>
                                    {/* Offer Letter File */}
                                    <td className="text-center align-middle">
                                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}>
                                        <label
                                          htmlFor={`offer-letter-${index}`}
                                          title="Upload Offer Letter"
                                          style={{ cursor: "pointer", margin: 0 }}
                                        >
                                          <i className="fa fa-cloud-upload" style={{ fontSize: "14px", color: "#27568B" }} />
                                        </label>
                                        <input
                                          id={`offer-letter-${index}`}
                                          type="file"
                                          accept=".jpg,.jpeg,.png,.pdf"
                                          onChange={(e) => handleEmploymentFileChange(e.target.files, index, "OfferLetter")}
                                          style={{ display: "none" }}
                                        />
                                        {(line.OfferLetterPreview || line.OfferLetter) && (
                                          <a
                                            href={
                                              line.OfferLetterPreview ||
                                              (typeof line.OfferLetter === "string" ? line.OfferLetter : "")
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="View Offer Letter"
                                          >
                                            <i className="fa fa-eye" style={{ fontSize: "14px", color: "#27568B", cursor: "pointer" }} />
                                          </a>
                                        )}
                                      </div>
                                    </td>
                                    {/* Salary Slip File */}
                                    <td className="text-center align-middle">
                                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}>
                                        <label
                                          htmlFor={`salary-slip-${index}`}
                                          title="Upload Salary Slip"
                                          style={{ cursor: "pointer", margin: 0 }}
                                        >
                                          <i className="fa fa-cloud-upload" style={{ fontSize: "14px", color: "#27568B" }} />
                                        </label>
                                        <input
                                          id={`salary-slip-${index}`}
                                          type="file"
                                          accept=".jpg,.jpeg,.png,.pdf"
                                          onChange={(e) => handleEmploymentFileChange(e.target.files, index, "SalarySlip")}
                                          style={{ display: "none" }}
                                        />
                                        {(line.SalarySlipPreview || line.SalarySlip) && (
                                          <a
                                            href={
                                              line.SalarySlipPreview ||
                                              (typeof line.SalarySlip === "string" ? line.SalarySlip : "")
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="View Salary Slip"
                                          >
                                            <i className="fa fa-eye" style={{ fontSize: "14px", color: "#27568B", cursor: "pointer" }} />
                                          </a>
                                        )}
                                      </div>
                                    </td>
                                    {/* Relieving Letter File */}
                                    <td className="text-center align-middle">
                                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}>
                                        <label
                                          htmlFor={`relieving-letter-${index}`}
                                          title="Upload Relieving / Exp. Letter"
                                          style={{ cursor: "pointer", margin: 0 }}
                                        >
                                          <i className="fa fa-cloud-upload" style={{ fontSize: "14px", color: "#27568B" }} />
                                        </label>
                                        <input
                                          id={`relieving-letter-${index}`}
                                          type="file"
                                          accept=".jpg,.jpeg,.png,.pdf"
                                          onChange={(e) => handleEmploymentFileChange(e.target.files, index, "RelievingLetter")}
                                          style={{ display: "none" }}
                                        />
                                        {(line.RelievingLetterPreview || line.RelievingLetter) && (
                                          <a
                                            href={
                                              line.RelievingLetterPreview ||
                                              (typeof line.RelievingLetter === "string" ? line.RelievingLetter : "")
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="View Relieving / Exp. Letter"
                                          >
                                            <i className="fa fa-eye" style={{ fontSize: "14px", color: "#27568B", cursor: "pointer" }} />
                                          </a>
                                        )}
                                      </div>
                                    </td>
                                    {/* Delete Button */}
                                    <td className="text-center align-middle">
                                      <a
                                        onClick={(e) => deleteLine(e, "employment_history", index)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="bi bi-trash"></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Additional identities */}
              <div
                className="tab-pane fade show"
                id="additional"
                role="tabpanel"
                aria-labelledby="additional-tab"
              >
                <div className="container-fluid mt-3">
                  <div className="row">
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Blood Group<span className="text-danger">*</span></label>
                        <Select
                          name="BloodGroup_062"
                          options={[
                            { value: "", label: "Select" },
                            ...bloodGroupOptions,
                          ]}
                          // value={formData?.BloodGroup_062}
                          value={bloodGroupOptions.find(
                            (option) =>
                              option.value === formData?.BloodGroup_062
                          )}
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>

                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Marital Status</label>
                        <Select
                          name="MaritalStatus_021"
                          options={[
                            { value: "", label: "Select" },
                            ...maritialStatusOptions,
                          ]}
                          // value={formData?.MaritalStatus_021}
                          value={maritialStatusOptions.find(
                            (option) =>
                              option.value === formData?.MaritalStatus_021
                          )}
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">Nationality</label>
                      <Select
                        options={[
                          { value: "", label: "Select" },
                          ...nationalityOptions,
                        ]}
                        // value={formData.Nationality}
                        name="Nationality"
                        value={nationalityOptions.find(
                          (option) => option.value === formData?.Nationality
                        )}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                      />
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Anniversary Date</label>
                        <CustomDatePicker
                          name="DateOfAnniversary"
                          id="DateOfAnniversary"
                          placeholderText="DD-MMM-YYYY"
                          readOnly={formData?.MaritalStatus_021 !== 140}
                          className="form-control"
                          value={formData?.DateOfAnniversary}
                          handleChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">
                          Appointment Date <span className="required">*</span>
                        </label>
                        <CustomDatePicker
                          name="AppointmentDate"
                          id="AppointmentDate"
                          placeholderText="DD-MMM-YYYY"
                          value={formData?.AppointmentDate}
                          handleChange={(e) => handleChange(e)}
                          required={true}
                          className={`form-control ${errors?.AppointmentDate ? "is-invalid" : ""
                            }`}
                        />
                        {errors.AppointmentDate && (
                          <span class="error">{errors?.AppointmentDate}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">
                          Joining Date<span className="required">*</span>
                        </label>
                        <CustomDatePicker
                          name="JoiningDate"
                          id="JoiningDate"
                          placeholderText="DD-MMM-YYYY"
                          value={formData?.JoiningDate}
                          handleChange={(e) => handleChange(e)}
                          // maxDate={false}
                          minDate={new Date(formData?.AppointmentDate)}
                          required={true}
                          className={`form-control ${errors?.JoiningDate ? "is-invalid" : ""
                            }`}
                        />
                        {errors.JoiningDate && (
                          <span class="error">{errors?.JoiningDate}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">
                          Payroll Joining Date
                          <span className="required">*</span>
                        </label>
                        <CustomDatePicker
                          name="PayrollJoiningDate"
                          id="PayrollJoiningDate"
                          placeholderText="DD-MMM-YYYY"
                          className="form-control"
                          value={formData?.PayrollJoiningDate}
                          handleChange={(e) => handleChange(e)}
                        />
                        {errors.PayrollJoiningDate && (
                          <span class="error">
                            {errors?.PayrollJoiningDate}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">
                          Branch<span className="required">*</span>
                        </label>
                        <Select
                          options={[
                            { value: "", label: "Select" },
                            ...branchOptions,
                          ]}
                          name="BranchID"
                          className={` ${errors?.BranchID ? "is-invalid" : ""}`}
                          value={branchOptions.find(
                            (option) => option.value === formData?.BranchID
                          )}
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />{" "}
                        {errors.BranchID && (
                          <span class="error">{errors?.BranchID}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Total Exp.(In Yrs)<span className="required">*</span></label>
                        <input
                          placeholder="Total Year Exp"
                          className="form-control text-end"
                          type="number"
                          name="TotalYearExp"
                          value={formData?.TotalYearExp}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.TotalYearExp && (
                          <span class="error">{errors?.TotalYearExp}</span>
                        )}
                      </div>
                    </div>
                      <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Total Exp.(In Mos.)<span className="required">*</span></label>
                        <input
                          placeholder="Total Months Exp"
                          className="form-control text-end"
                          type="number"
                          name="TotalMonthExp"
                          value={formData?.TotalMonthExp}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.TotalMonthExp && (
                          <span class="error">{errors?.TotalMonthExp}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">PF Nominee Name<span className="text-danger">*</span></label>
                        <input
                          placeholder="PF Nominee Name"
                          className="form-control"
                          type="text"
                          name="PFNomineeName"
                          value={formData?.PFNomineeName || ""}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">PF Nominee Relation<span className="text-danger">*</span></label>
                        <input
                          placeholder="PF Nominee Relation"
                          className="form-control"
                          type="text"
                          name="PFNomineeRelation"
                          value={formData?.PFNomineeRelation || ""}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                     {formData?.MaritalStatus_021 === 140 && (
                      <>
                        <div className="col-sm-2">
                          <div>
                            <label className="form-label">Spouse Name</label>
                            <input
                              placeholder="Spouse Name"
                              className="form-control"
                              type="text"
                              name="SpouseName"
                              value={formData?.SpouseName}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>

                        <div className="col-sm-2">
                          <div>
                            <label className="form-label">Spouse D.O.B</label>
                            <CustomDatePicker
                              name="SpouseDOB"
                              id="SpouseDOB"
                              placeholderText="DD-MMM-YYYY"
                              className="form-control"
                              value={formData?.SpouseDOB}
                              handleChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                      </>
                    )}
                </div>
                <div className="row mt-3">
                  {formData?.MaritalStatus_021 === 140 && (
                      <>
                     <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Child 1 Name</label>
                        <input
                          placeholder="Child 1 Name"
                          className="form-control"
                          type="text"
                          name="Child1Name"
                          value={formData?.Child1Name}
                          onChange={(e) => handleChange(e)}
                        />
                        {/* {errors.BranchID && (
                          <span class="error">{errors?.BranchID}</span>
                        )} */}
                      </div>
                    </div>
                     <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Child 1 D.O.B</label>
                        <CustomDatePicker
                          name="Child1DOB"
                          id="Child1DOB"
                          placeholderText="DD-MMM-YYYY"
                          readOnly={formData?.MaritalStatus_021 !== 140}
                          className="form-control"
                          value={formData?.Child1DOB}
                          handleChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                     <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Child 2  Name</label>
                        <input
                          placeholder="Child 2 Name"
                          className="form-control "
                          type="text"
                          name="Child2Name"
                          value={formData?.Child2Name}
                          onChange={(e) => handleChange(e)}
                        />
                        {/* {errors.BranchID && (
                          <span class="error">{errors?.BranchID}</span>
                        )} */}
                      </div>
                    </div>
                     <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Child 2 D.O.B</label>
                        <CustomDatePicker
                          name="Child2DOB"
                          id="Child2DOB"
                          placeholderText="DD-MMM-YYYY"
                          readOnly={formData?.MaritalStatus_021 !== 140}
                          className="form-control"
                          value={formData?.Child2DOB}
                          handleChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="mt-3"></div>
                    </>
                    )}
                 <div className="d-flex flex-wrap align-items-center gap-5">
                    <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  name="OnPayroll"
                                                  checked={formData?.OnPayroll === "1"}
                                                  onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label">OnPayroll</label>
                                              </div>

                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  name="IsIntern"
                                                  checked={formData?.IsIntern === "1"}
                                                  onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label">Apprenticeship</label>
                                              </div>

                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  name="IsPartTime"
                                                  checked={formData?.IsPartTime === "1"}
                                                  onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label">PartTime</label>
                                              </div>

                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  name="Bond"
                                                  checked={formData?.Bond === "1"}
                                                  onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label">Bond</label>
                                              </div>

                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  name="Incentives"
                                                  checked={formData?.Incentives === "1"}
                                                  onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label">Incentives</label>
                                              </div>

                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  name="JoiningBonus"
                                                  checked={formData?.JoiningBonus === "1"}
                                                  onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label">Joining Bonus</label>
                                              </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
            <div className="container-fluid d-flex justify-content-end mt-2">
              <div>
                <button
                  type="button"
                  className="cancel-btn me-2"
                  onClick={() => navigate("/employee-list")}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className={`custom-btn ${submitted ? "submitting" : ""}`}
                  disabled={submitted}
                  aria-disabled={submitted}
                  aria-busy={submitted}
                  style={{
                    cursor: submitted ? "not-allowed" : "pointer",
                    opacity: submitted ? 0.7 : 1,
                  }}
                >
                  {submitted ? (
                    <>
                      <FaSpinner
                        className="sm-spinner spin"
                        aria-hidden="true"
                      />
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </>
    );
  }
};

export default EmployeeAdd;
